import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EditWhite, IconClose, IconDelete, Star } from '../../img'; //IconDelete IconInformation,
import './Integration.scss';
// import Dropdown from 'react-dropdown';
import ReactTooltip from 'react-tooltip';
import { browserHistory } from 'react-router';
import ImageUploader from 'react-images-upload';
import Dropdown from 'react-dropdown';
import { Modal } from 'components';
import { Link } from 'react-router';
import {
  getUsIntMst, getFBPostInt,
  createFBPage, deleteFBList, deleteFB,
  getFBReviewInt, createFBReviewIntIA, deleteFBReviewIntIA, deleteFBReviewInt, updADUsInt,
  createGMBPostIntIA, getGGLPostInt, deleteGGLPostIntIA, deleteGGLPostInt,
  createGGLReviewIntIA, getGGLReviewInt, deleteGGLReviewIntIA, deleteGGLReviewInt,
  getTwitPostInt, createTwitterUN, deleteTwitter, updateFilter, getIntMstList, getInstaPostInt, createInstaPostInt, deleteInstaPostInt,
  getGooglePlace, createGooglePlace, deleteGooglePlace, getCapterra, createCapterra, deleteCapterra,
  syncReviews, getWebhook, createWebhook, deleteWebhook, twitterOauth, deleteUNorTag, getRSS, createRSS, deleteRSS,
  getTumblr, createTumblr, deleteTumblr, getWidgetForInt, getBooking, createBooking, deleteBooking,
  getTripAdvisor, createTripAdvisor, deleteTripAdvisor, getTrustpilot, createTrustpilot, deleteTrustpilot,
  getAirbnb, createAirbnb, deleteAirbnb, getYelp, createYelp, deleteYelp, getHotels, createHotels, deleteHotels,
  getEtsy, createEtsy, deleteEtsy, getHouzz, createHouzz, deleteHouzz, getEdmunds, createEdmunds, deleteEdmunds,
  getDealerRater, createDealerRater, deleteDealerRater, getOpenTable, createOpenTable, deleteOpenTable,
  geteBay, createeBay, deleteeBay, getBBB, createBBB, deleteBBB, getAmzon, createAmzon, deleteAmzon,
  getGooglePlay, createGooglePlay, deleteGooglePlay, getAppleAPP, createAppleAPP, deleteAppleAPP, syncLastestPages,
  getReviews, getAppSumo, createAppSumo, deleteAppSumo, updateReview, getImages, deleteImage, setIconImageURL,
  deleteReview, removeImage, addCutomReview, getCustomReview, createCustomReview, deleteCustomReview,
  downloadExcelData, getCustomWebhook, createCustomWebhook, deleteCustomWebhook, getCustomWBField, addCustomField,
  deleteCustomField, updCustomField, getCustomCollectorReview, createCustomCollectorReview, deleteCustomCollectorReview,
  getAliexpress, createAliexpress, deleteAliexpress, getG2, createG2, deleteG2, getYouTubeVideoGallery, createYouTubeVideoGallery, deleteYouTubeVideoGallery,
  getStamped, createStamped, deleteStamped, createTumblrPostInt, deleteTumblrPostInt, deleteInstaPost, getImportreview, createImportReview, deleteImportReview,
  uploadCSV, getTwitterTestimonial, createTwitterTestimonial, deleteTwitterTestimonial
} from '../../ducks/integration';
import {
  addDataSrc,
  delDataSrc,
} from '../../ducks/widget';
import {
  FacebookPost, FacebookReview, GooglePost, GoogleReview, TwitterPost, InstaPost, GooglePlace, Tumblr,
  Capterra, RSS, Webhook, Booking, TripAdvisor, Trustpilot, Airbnb, Yelp, Hotels, Etsy, Edmunds, DealerRater,
  Houzz, OpenTable, Ebay, BBB, Amzon, GooglePlay, AppleApp, AppSumo, CustomReview, CustomWebhook, CustomCollectorReview,
  Aliexpress, G2, YouTubeVideoGallery, Stamped, ImportReviews, TwitterTestimonial
} from 'components';
import SlidingPanel from 'react-sliding-side-panel';
import { confirmAlert } from 'react-confirm-alert';
import SimpleReactValidator from 'simple-react-validator';
import copy from 'copy-to-clipboard';
// import { toast } from 'react-toastify';
import toast from '../../components/Toastify';
import ContentLoader from 'react-content-loader';
let arrDataSource = [];
const moment = require('moment');
let timeInt = '';
let FieldInterval = '';

const getDemoCsv = () => {
  let CSV = 'https://storage.googleapis.com/wiser_goal/integration/Import_review_demo_CSV.csv?t=1662017190461';
  window.location.href = CSV;
};

const TableRow = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <ContentLoader
      height={40}
      width={1060}
      speed={2}
      primaryColor="#fff"
      secondaryColor="#eceef4"
      {...props}
    >
      <rect x="0" y="15" rx="4" ry="4" width="6" height="6.4" />
      <rect x="38" y="13" rx="6" ry="6" width={40 * random} height="12" />
      <rect x="180" y="13" rx="6" ry="6" width={200 * random} height="12" />
      <rect x="230" y="13" rx="6" ry="6" width={78 * random} height="12" />
      <rect x="420" y="13" rx="6" ry="6" width={117 * random} height="12" />
      <rect x="690" y="13" rx="6" ry="6" width={83 * random} height="12" />
      <rect x="830" y="13" rx="6" ry="6" width={63 * random} height="12" />
      <rect x="1000" y="13" rx="6" ry="6" width={63 * random} height="12" />
      <rect x="0" y="39" rx="6" ry="6" width="1060" height=".3" />
    </ContentLoader>
  );
};

// const TableRow1 = props => {
//   return (
//     <ContentLoader
//       height={40}
//       width={1060}
//       speed={2}
//       primaryColor="#fff"
//       secondaryColor="#eceef4"
//       {...props}
//     >
//       <rect x="0" y="15" rx="4" ry="4" width="6" height="6.4"></rect>
//       <rect x="38" y="13" rx="6" ry="6" width="200" height="100"></rect>
//       <rect x="330" y="13" rx="6" ry="6" width="300" height="200"></rect>
//       <rect x="730" y="13" rx="6" ry="6" width="400" height="200"></rect>
//       <rect x="0" y="39" rx="6" ry="6" width="1060" height=".3"></rect>
//     </ContentLoader>
//   );
// };
let starImg = <img className='drop-strs' src={Star} />;
const ratingOption = [
  { value: '1', label: <div>{starImg}</div> },
  { value: '2', label: <div>{starImg}{starImg}</div> },
  { value: '3', label: <div>{starImg}{starImg}{starImg}</div> },
  { value: '4', label: <div>{starImg}{starImg}{starImg}{starImg}</div> },
  { value: '5', label: <div>{starImg}{starImg}{starImg}{starImg}{starImg}</div> }
];

const sourceOption = [
  { value: 'google', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/ggle.svg" /><span>&nbsp; Google</span></div> },
  { value: 'facebook', label: <div> <img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/fb.svg" /><span>&nbsp; Facebook</span></div> },
  { value: 'twitterpost', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/twit.svg" /><span>&nbsp; Twitter</span></div> },
  { value: 'instagrampost', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/insta.svg" /><span>&nbsp; Instagram</span></div> },
  { value: 'linkedin', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/in.svg" /> <span>&nbsp; Linkedin</span> </div> },
  { value: 'g2', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/g2.svg" /><span>&nbsp; G2</span> </div> },
  { value: 'appsumo', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-appsumo.svg" /><span>&nbsp; Appsumo</span></div> },
  { value: 'capterra', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/cap.svg" /><span>&nbsp; Capterra</span></div> },
  { value: 'yelp', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-yelp.svg" /><span>&nbsp; Yelp</span></div> },
  { value: 'amazon', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-amazon.svg" /><span>&nbsp; Amazon</span></div> },
  { value: 'reviewsio', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-reviewsio.svg" /><span>&nbsp; Reviews.io</span></div> },
  { value: 'tripadvisor', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-tripadvisor.svg" /><span>&nbsp; Tripadvisor</span></div> },
  { value: 'airbnb', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-airbnb.svg" /> <span>&nbsp; Airbnb</span></div> },
  { value: 'booking', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-booking.svg" /><span>&nbsp; Booking.com</span></div> },
  { value: 'repuso', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/wiser_goal/integration/repuso.png" /> <span>&nbsp; Repuso</span></div> },
  { value: 'edmunds', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-edmunds.svg" /><span>&nbsp; Edmunds</span></div> },
  { value: 'practo', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-practo.svg" /><span>&nbsp; Practo</span></div> },
  { value: 'hotels', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-hotelsin.svg" /><span>&nbsp; Hotels</span></div> },
  { value: 'etsy', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/icon-etsy.svg" /><span>&nbsp; Etsy</span></div> },
  { value: 'custom', label: <div><img className='drop-ICons' src="https://storage.googleapis.com/widget_img/widget/default-star.svg" /><span>&nbsp; Custom</span></div> },
];
// window.onclick = function (event) {
//   if (
//     event.target &&
//     event.target.parentNode &&
//     event.target.parentNode.offsetParent &&
//     event.target.parentNode.offsetParent.className
//   ) {
//     let className = '';
//     if (
//       event.srcElement.className == 'dd-default-block' ||
//       event.target.parentNode.offsetParent.className == 'dd-default-block'
//     ) {
//       className = event.srcElement.className == 'dd-default-block' ? event.srcElement.className : event.target.parentNode.offsetParent.className;
//     }
//     if (className !== 'dd-default-block') {
//       console.log(className, '====className');
//     }
//   }
// };
class Integration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stul: '',
      img: '',
      dn: '',
      desc: '',
      intISActive: false,
      usIntId: '',
      in: '',
      openClose: false,
      hideShowDrp: false,
      intDropUniq: '',
      un: '',
      rmk: '',
      searchGMBPG: '',
      lng: 'en',//Google place review language
      place_id: '',
      isDisable: false,
      searchByApp: '',
      curl: '',//Product URL for capterra
      filterIntType: '',//Review or feed
      t: '',//Webhook type
      tl: '',//Database tooltip
      webhookURL: '',//For Copy endpoint
      slug: '',//twitter slug name
      widgetListData: [],
      islstIntLoading: false,
      isIntegration: false,
      isAPICall: false,
      isOpenCloseFilter: false,
      itwtpst: false,//Filter Show original tweet
      itwtrpls: false,//Filter Show reply tweet
      itwtrtwt: false,//Filter Show re-tweet
      twitterUNid: '',
      isFromInt: '',//For Twitter Update dataSource
      isAllInOne: false,//For Show search box when widget is all in One
      searchByName: '',//Search by google location name
      isHideShowInt: false,//Hide Show integration div
      openCloseSideDataPanel: false,//Hide show review data side panel
      isLoaderForReviewDiv: false,//Loader for review slider
      reviewDataItems: [],//Store review Data
      pageNoReview: 0,//Page Number For Review
      reviewFuid: '',//When Edit Integration store Integration id
      totalCountOfData: 0,//No of review count
      openCloseData: false,
      msg: '',
      rtxt: '',
      rtng: '5',
      fuid: '',
      openCloseIconModel: false,
      iconLable: '',
      cptntxt: '',
      wbstlnk: '',
      wbstlg: '',
      dnForEditRevie: '',
      iconLoader: false,
      wbstlg1: '',
      piu: '',
      piu1: '',
      reviewPgId: '',
      openCloseSideCustomPanel: false,
      openCloseSideCustomData: false,
      isAddnewRec: false,
      isExcelDownload: false,
      openCloseCustomWBPanel: false,
      custkeyword: '',
      custvalue: '',
      epURL: '',
      pgid: '',
      ak: '',
      dname: '',
      puak: '',//Public API Key
      prak: '',//Private API Key
      sh: '',//Store hash
      stpd: '',//Product id
      isCallInterVal: false,
      isOpenDirectReviewModel: false,
      isFromDSI: false,
      isCreatingIntegration: false,
      selectedFile: '',
      adcr: '0',//Add custom review radio button
      imField: '',//image field like website logo or review image
      tgOption: '@',
      webhookList: [],
      othrtl: ''
    };
    this.validator = new SimpleReactValidator();
    this.ytValidator = new SimpleReactValidator();
    this.rtValidator = new SimpleReactValidator();
  }

  componentDidMount() {
    //Click on Add integration on datasource page
    if (this.props.widgetById) {
      this.state.dname = this.props.widgetById.wdsc;
    }
    if (this.props.wtn) {
      this.setState({
        filterIntType: this.props.wtn
      });
    }
    if (this.props.filterType) {
      this.setState({
        filterIntType: this.props.filterType
      });
    }
    const params = (new URL(window.location)).searchParams;
    this.props.getImages();
    this.props.getWidgetForInt();
    const allInOne = params.get('wdtnm');
    if (allInOne == 'allinonepost' || allInOne == 'allinonereview') {
      this.state.isAllInOne = true;
      this.setState(this.state);
    }
    //redirect after any OAuth complete then filter specific integration
    if (this.props.location && this.props.location.query && this.props.location.query.int) {
      this.setState({
        searchByApp: this.props.location.query.int
      });
      browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + '/integration');
    }
    // let arrWidget = [];
    // if (
    //   this.props.allProps &&
    //   this.props.allProps.userWidget &&
    //   this.props.allProps.userWidget.length > 0
    // ) {
    //   for (let i = 0; i < this.props.allProps.userWidget.length; i++) {
    //     const element = this.props.allProps.userWidget[i];
    //     for (let j = 0; j < element.dsi.length; j++) {
    //       const element1 = element.dsi[j];
    //       arrWidget.push({
    //         'uid': element1.uid,
    //         'cn': element.cn,
    //         'rmk': element1.rmk,
    //         'url': element1.url,
    //         'dn': element1.dn,
    //         'pid': element1.pid,
    //         'wdsc': element.wdsc,
    //         'wdid': element._id
    //       });
    //     }
    //   }
    // }
    // this.state.widgetListData = arrWidget;
    // this.setState(this.state);

    //Event Listner for Close Filter drop down 
    let that = this;
    document.body.addEventListener('click', function (event) {
      //window.onclick = function (event) {
      if (
        event.target &&
        event.target.parentNode &&
        event.target.parentNode.offsetParent &&
        event.target.parentNode.offsetParent.className
      ) {
        let className = '';
        if (
          event.srcElement.className == 'dd-default-block' ||
          event.target.parentNode.offsetParent.className == 'dd-default-block'
        ) {
          className = event.srcElement.className == 'dd-default-block' ? event.srcElement.className : event.target.parentNode.offsetParent.className;
        }
        if (
          className !== 'dd-default-block' &&
          that.state.isOpenCloseFilter == true
        ) {
          that.setState({
            isOpenCloseFilter: false,
            itwtpst: false,
            itwtrpls: false,
            itwtrtwt: false,
          });
        }
      }
    }, true);
    if (this.props.allProps.lstActiveIntg && this.props.state.usIntObj && this.props.state.usIntObj.inm && localStorage.getItem('W_DIR_TBINT')) {
      let filterData = this.props.allProps.lstActiveIntg.filter(x => x.in == this.props.state.usIntObj.inm);
      filterData[0]['fromLocalStorage'] = true;
      this.opCLIntModel(filterData[0]);
    }
    const intName = localStorage.getItem('W_TBINT');
    if (this.props.allProps.lstActiveIntg && intName) {
      let filterData = this.props.allProps.lstActiveIntg.filter(x => x.in == intName);
      localStorage.removeItem('W_TBINT');
      filterData[0]['fromLocalStorage'] = true;
      this.opCLIntModel(filterData[0]);
    }
    const paramInt = params.get('intds');
    if (this.props.allProps.lstActiveIntg && paramInt) {
      let filterData = this.props.allProps.lstActiveIntg.filter(x => x.in == this.props.state.compIntegration);
      localStorage.removeItem('W_TBINT');
      filterData[0]['fromLocalStorage'] = true;
      this.opCLIntModel(filterData[0]);
      let authURL = window.location.href.replace('#_=_', '');
      browserHistory.push(authURL.replace(`&intds=${paramInt}`, ''));
    }
  }

  componentWillReceiveProps(nextprops) {
    if (!nextprops.customWBFields && !this.props.customWBFields && this.state.openCloseCustomWBPanel) {
      this.intervalCustomFields();
    }
    if (nextprops.customWBFields != this.props.customWBFields && this.state.openCloseCustomWBPanel) {
      if (nextprops.customWBFields && nextprops.customWBFields.resp && nextprops.customWBFields.resp.length > 0) {
        clearInterval(FieldInterval);
      } else {
        this.intervalCustomFields();
      }
    }
    // if (this.props.userIntegration != nextprops.userIntegration && this.state.isAPICall === false) {
    //   //Set true value in localstorage for Loader.
    //   //Set 30 sec time interval for call get API.
    //   if (this.props.userIntegration && this.props.userIntegration.length > 0) {
    //     console.log(this.props.userIntegration, '===this.props.userIntegrationprop');
    //     this.setState({
    //       isAPICall: true
    //       //islstIntLoading: true
    //     });
    //     this.chkInterval();
    //   }
    // }
  }

  componentDidUpdate(prevProps) {
    const intName = localStorage.getItem('W_TBINT');
    if (this.props.allProps.lstActiveIntg && intName) {
      let filterData = this.props.allProps.lstActiveIntg.filter(x => x.in == intName);
      localStorage.removeItem('W_TBINT');
      filterData[0]['fromLocalStorage'] = true;
      this.opCLIntModel(filterData[0]);
    }
    // if (this.props.userIntegration != prevProps.userIntegration) {
    //   this.setState({
    //     islstIntLoading: false
    //   });
    // }
    // else if (this.props.isLoader != prevProps.isLoader) {
    //   this.setState({
    //     islstIntLoading: this.props.isLoader
    //   });
    // }
    if ((this.props.reviewsData && this.props.reviewsData.data) != (prevProps.reviewsData && prevProps.reviewsData.data)) {
      this.state.reviewDataItems = [...this.props.reviewsData.data, ...this.state.reviewDataItems];
      this.state.reviewDataItems.sort(function (a, b) { return new Date(b.insdt) - new Date(a.insdt); });
      if (this.props.reviewsData.count) {
        this.state.totalCountOfData = this.props.reviewsData.count;
      }
      // if (this.props.reviewsData.count && this.props.reviewsData.count > 11) {
      //   document.getElementById('edit_scroll').style.height = '83vh';
      //   document.getElementById('edit_scroll').style.overflowY = 'scroll';
      // }
      this.state.isLoaderForReviewDiv = false;
      this.setState(this.state);
    }
    if (this.props.iconImages != prevProps.iconImages) {
      this.state.iconLoader = false;
      this.setState(this.state);
    }
    if (this.props.deleteReviewID != prevProps.deleteReviewID) {
      this.props.fnGetWidgetData();
    }
    if (this.props.updReview != prevProps.updReview) {
      this.props.fnGetWidgetData();
    }
    if (this.props.excelDownload != prevProps.excelDownload) {
      this.setState({
        isExcelDownload: false
      });
    }
    // if (this.props.widgetById != prevProps.widgetById) {
    //   let arrWidget = [];
    //   if (this.props.widgetById.dsi) {
    //     for (let i = 0; i < this.props.widgetById.dsi.length; i++) {
    //       const element = this.props.widgetById.dsi[i];
    //       arrWidget.push({
    //         'uid': element.uid,
    //         'cn': element.cn,
    //         'rmk': element.rmk,
    //         'url': element.url,
    //         'dn': element.dn,
    //         'pid': element.pid,
    //         'wdsc': element.wdsc,
    //       });
    //     }
    //     this.state.widgetListData = arrWidget;
    //     this.setState(this.state);
    //   }
    // }
    // if (this.props.allProps != prevProps.allProps) {
    //   let arrWidget = [];
    //   if (
    //     this.props.allProps &&
    //     this.props.allProps.userWidget &&
    //     this.props.allProps.userWidget.length > 0
    //   ) {
    //     for (let i = 0; i < this.props.allProps.userWidget.length; i++) {
    //       const element = this.props.allProps.userWidget[i];
    //       for (let j = 0; j < element.dsi.length; j++) {
    //         const element1 = element.dsi[j];
    //         arrWidget.push({
    //           'uid': element1.uid,
    //           'cn': element.cn,
    //           'rmk': element1.rmk,
    //           'url': element1.url,
    //           'dn': element1.dn,
    //           'pid': element1.pid,
    //           'wdsc': element.wdsc,
    //           'wdid': element._id
    //         });
    //       }
    //     }
    //   }
    //   this.state.widgetListData = arrWidget;
    //   this.setState(this.state);
    // }
    if (this.props.webhooks != prevProps.webhooks) {
      this.state.webhookList = this.props.webhooks;
      this.setState(this.state);
    }
  }

  //Initialize state
  initState = () => {
    this.setState({
      un: '',
      rmk: '',
      sa: '',
      searchGMBPG: '',
      lng: 'en',
      place_id: '',
      searchByApp: '',
      curl: '',
      slug: '',
      ak: '',
      pi: '',
      urn: '',
      dname: '',
      puak: '',//Public API Key
      prak: '',//Private API Key
      sh: '',//Store hash
      stpd: '',//Product id
    });
  }

  removeParam = (key, sourceURL) => {
    var rtn = sourceURL.split('?')[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';
    if (queryString !== '') {
      params_arr = queryString.split('&');
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split('=')[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
    }
    return rtn;
  }

  //open integration model
  opCLIntModel = (obj) => {
    // let arrWidget = [];
    // if (
    //   this.props.allProps &&
    //   this.props.allProps.userWidget &&
    //   this.props.allProps.userWidget.length > 0
    // ) {
    //   for (let i = 0; i < this.props.allProps.userWidget.length; i++) {
    //     const element = this.props.allProps.userWidget[i];
    //     for (let j = 0; j < element.dsi.length; j++) {
    //       const element1 = element.dsi[j];
    //       let filterWidget = arrWidget.filter(x =>
    //         x.wdid == element._id &&
    //         x.pid == element.pid &&
    //         x.uid == element.uid
    //       );
    //       if (filterWidget.length == 0) {
    //         arrWidget.push({
    //           'uid': element1.uid,
    //           'cn': element.cn,
    //           'rmk': element1.rmk,
    //           'url': element1.url,
    //           'dn': element1.dn,
    //           'pid': element1.pid,
    //           'wdsc': element.wdsc,
    //           'wdid': element._id
    //         });
    //       }
    //     }
    //   }
    // }
    // this.state.widgetListData = arrWidget;
    // this.setState(this.state);
    // if (obj.in == 'customreview') {
    //   obj['openCloseSideCustomPanel'] = true;
    //   this.setState(obj);
    // } else {
    if (obj.in == 'facebookpost') {
      this.props.getFBPostInt();
    }
    else if (obj.in == 'facebook') {
      this.props.getFBReviewInt(obj);
    }
    else if (obj.in == 'googlepost') {
      this.props.getGGLPostInt();
    }
    else if (obj.in == 'googlemybusiness') {
      this.props.getGGLReviewInt(obj);
    }
    else if (obj.in == 'twitterpost') {
      this.props.getTwitPostInt();
    }
    else if (obj.in == 'instagrampost') {
      this.props.getInstaPostInt();
    }
    else if (obj.in == 'google') {
      this.props.getGooglePlace(obj);
    }
    else if (obj.in == 'capterra') {
      this.props.getCapterra(obj);
    }
    else if (obj.in == 'rsspost') {
      this.props.getRSS();
    }
    else if (obj.in == 'tumblrpost') {
      this.props.getTumblr();
    }
    else if (obj.in == 'booking') {
      this.props.getBooking();
    }
    else if (obj.in == 'tripadvisor') {
      this.props.getTripAdvisor();
    }
    else if (obj.in == 'trustpilot') {
      this.props.getTrustpilot();
    }
    else if (obj.in == 'airbnb') {
      this.props.getAirbnb();
    }
    else if (obj.in == 'yelp') {
      this.props.getYelp();
    }
    else if (obj.in == 'hotels') {
      this.props.getHotels();
    }
    else if (obj.in == 'etsy') {
      this.props.getEtsy();
    }
    else if (obj.in == 'houzz') {
      this.props.getHouzz();
    }
    else if (obj.in == 'edmunds') {
      this.props.getEdmunds();
    }
    else if (obj.in == 'dealerrater') {
      this.props.getDealerRater();
    }
    else if (obj.in == 'opentable') {
      this.props.getOpenTable();
    }
    else if (obj.in == 'ebay') {
      this.props.geteBay();
    }
    else if (obj.in == 'bbb') {
      this.props.getBBB();
    }
    else if (obj.in == 'amazon') {
      this.props.getAmzon();
    }
    else if (obj.in == 'googleplay') {
      this.props.getGooglePlay();
    }
    else if (obj.in == 'appleapp') {
      this.props.getAppleAPP();
    }
    else if (obj.in == 'appsumo') {
      this.props.getAppSumo();
    }
    else if (obj.in == 'customreview') {
      this.props.getCustomReview();
    }
    else if (obj.in == 'g2review') {
      this.props.getG2();
    }
    else if (obj.in == 'custom') {
      this.props.getCustomWebhook(this.props.widgetById._id);
    }
    else if (obj.in == 'aliexpressreview') {
      this.props.getAliexpress();
    }
    else if (obj.in == 'customcollectorreview') {
      this.props.getCustomCollectorReview(this.props.widgetById._id);
    }
    else if (obj.in == 'youtubevideogallery') {
      this.props.getYouTubeVideoGallery();
    }
    else if (obj.in == 'stamped') {
      this.props.getStamped();
    }
    else if (obj.in == 'importreviews') {
      this.props.getImportreview();
    }
    else if (obj.in == 'twittertestimonial') {
      this.props.getTwitterTestimonial();
    }
    else if (obj.t == 0) {
      this.props.getWebhook(obj.in);
    }
    if (obj.isListening != true) {
      if (obj.fromLocalStorage == true) {
        obj.openClose = true;
      } else {
        obj.openClose = !this.state.openClose;
      }
      if (obj.openClose === true) {
        // this.state.islstIntLoading = true;
        this.setState(this.state);
      }
      this.setState(obj);
    }
    if (this.props && this.props.state && this.props.state.usIntObj && localStorage.getItem('W_DIR_TBINT')) {
      // console.log(data.isOpenDirectReviewModel, '===data.isOpenDirectReviewModel ');
      this.openDirectReviewModel(this.props.state.usIntObj);
      localStorage.removeItem('W_DIR_TBINT');
    }
    //}
  }

  //installed integration
  intIntegration = () => {
    setTimeout(() => {
      if (document.getElementById('instDiv') && document.getElementById('instDiv').childNodes.length == 0) {
        document.getElementById('instDiv').innerHTML = '<p>Currently, You do not have any active integration yet.</p>';
      }
    }, 100);
  }

  //handle drop down like Facebook page
  //hdffp:handle drop down for facebook page
  handleDropdown = (key) => {
    this.setState({
      hideShowDrp: !this.state.hideShowDrp,
      intDropUniq: key
    });
  }

  //close integration model
  closeModal = () => {
    this.state.openClose = !this.state.openClose;
    this.setState(this.state);

  }

  //handleIsActive:handle active deactive user integration
  handleIsActive = (id, ia) => {
    this.state.intISActive = ia;
    this.state.usIntId = id;
    this.setState(this.state);
    this.props.updADUsInt({ id: id, ia: ia });
  }

  //handle state change
  handleStateChangeInt = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  copyEndpoint = (value) => {
    copy(value, { debug: true });
    this.state.webhookURL = value;
    this.setState(this.state);
    if (!toast.isActive(this.toastId)) {
      this.toastId = toast.success('Endpoint copied');
    }
    return;
  }

  //Facebook Post
  //Create facebook userintegration
  createFBPage = (obj) => {
    this.setState({
      islstIntLoading: true
    });
    // obj['pgid'] = obj.id;
    this.props.createFBPage(obj);
  }

  //delete
  deleteFB = (id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => {
        //           browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist');
        //           onClose();
        //         }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteFB(id);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  deleteFBList = (obj) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, obj._id, obj.pgid);
    // let delObj = { pgid: obj.id, _id: obj._id };
    //let data = this.state.widgetListData.filter(x => x._id === obj._id);
    // let arrWidgetNames = [];
    // let data = this.state.widgetListData.filter(x => {
    //   if (x.uid === delObj._id && x.pid === delObj.pgid) {
    //     return x;
    //   }
    // });
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (data && data.length > 0) {
        //   data.map((x) => {
        //     arrWidgetNames.push(x.wdsc);
        //   });
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteFBList(obj);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  //Facebook Review
  //Update
  createFBPageReview = (obj) => {
    this.setState({
      islstIntLoading: true
    });
    // obj['pgid'] = obj.id;
    this.props.createFBReviewIntIA(obj);
  }

  //Delete
  deleteFBListReview = (obj) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, obj._id, obj.id);
    // let arrWidgetNames = [];
    // let data = this.state.widgetListData.filter(x => {
    //   if (x.uid === obj._id && x.pid === obj.id) {
    //     return x;
    //   }
    // });
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (data && data.length > 0) {
        //   data.map((x) => {
        //     arrWidgetNames.push(x.wdsc);
        //   });
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteFBReviewIntIA(obj);
                  this.setState({
                    isList: false,
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  deleteFBReview = (id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push('process.env.REACT_APP_ROUTE_PREFIX +wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteFBReviewInt(id);
                  this.setState({
                    isList: false,
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  // //Google Post
  // //Create
  // createGMBPostIntIA = (obj) => {
  //   this.setState({
  //     islstIntLoading: true
  //   });
  //   this.props.createGMBPostIntIA(obj);
  // }

  // //delete
  // deleteGGLPostIntIA = (obj) => {
  //   let data = this.state.widgetListData.filter(x => x._id === obj._id);
  //   confirmAlert({
  //     closeOnEscape: false,
  //     closeOnClickOutside: false,
  //     customUI: ({ onClose }) => {
  //       if (data && data.length > 0) {
  //         return (
  //           <div className='custom-ui'>
  //             <h1>This data source is already in use!</h1>
  //             <p>Kindly disable this data-source from <b><i>{data[0].data.toString()}</i></b> Widget first & After that, you can delete it.</p>
  //             <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
  //               onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
  //               Go to Widget
  //             </button>
  //             <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
  //               <span className="nf-btn-span">Cancel</span>
  //             </button>
  //           </div>
  //         );
  //       }
  //       else {
  //         return (
  //           <div className='custom-ui'>
  //             <h1> Are you sure want to delete this record?</h1>
  //             <p>By clicking yes, you will lose the current  record.</p>
  //             <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
  //               onClick={() => {
  //                 this.props.deleteGGLPostIntIA(obj);
  //                 this.setState({
  //                   islstIntLoading: true
  //                 });
  //                 onClose();
  //               }}>
  //               Yes, Delete record
  //             </button>
  //             <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
  //               <span className="nf-btn-span">Cancel</span>
  //             </button>
  //           </div>
  //         );
  //       }
  //     }
  //   });
  // }

  // deleteGGLPostInt = (_id) => {
  //   let data = this.state.widgetListData.filter(x => x._id === _id);
  //   confirmAlert({
  //     closeOnEscape: false,
  //     closeOnClickOutside: false,
  //     customUI: ({ onClose }) => {
  //       if (data && data.length > 0) {
  //         return (
  //           <div className='custom-ui'>
  //             <h1>This data source is already in use!</h1>
  //             <p>Kindly disable this data-source from <b><i>{data[0].data.toString()}</i></b> Widget first & After that, you can delete it.</p>
  //             <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
  //               onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
  //               Go to Widget
  //             </button>
  //             <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
  //               <span className="nf-btn-span">Cancel</span>
  //             </button>
  //           </div>
  //         );
  //       }
  //       else {
  //         return (
  //           <div className='custom-ui'>
  //             <h1> Are you sure want to delete this record?</h1>
  //             <p>By clicking yes, you will lose the current  record.</p>
  //             <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
  //               onClick={() => {
  //                 this.props.deleteGGLPostInt(_id);
  //                 this.setState({
  //                   islstIntLoading: true
  //                 });
  //                 onClose();
  //               }}>
  //               Yes, Delete record
  //             </button>
  //             <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
  //               <span className="nf-btn-span">Cancel</span>
  //             </button>
  //           </div>
  //         );
  //       }
  //     }
  //   });
  // }

  //Twitter Post
  createTwitterUN = (e, userIntegration) => {
    const { slug, tgOption } = this.state;
    e.preventDefault();
    let that = this;

    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        slug: tgOption + slug,
        id: userIntegration._id
      };
      this.props.createTwitterUN(obj);
      this.initState();
      this.setState({
        islstIntLoading: true
      });
    }
  }

  createOAuth = () => {
    // let obj = {
    //   widgetById: this.props.state.widgetById,
    //   wdsc: this.props.state.wdsc,
    //   isEditWidget: this.props.state.isEditWidget
    // };
    this.state.isCreatingIntegration = true;
    this.setState(this.state);
    let URLs = window.location.href + '&tb=ds&intds=twitterpost';
    //localStorage.setItem('W_WDGT_CRT', JSON.stringify(obj));
    this.props.twitterOauth(encodeURIComponent(URLs));
  }

  deleteTwitter = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteTwitter(_id);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  groupBy = (xs, key, uid) => {
    return xs.filter(x => x.uid == uid).reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x.wdsc);
      return rv;
    }, {});
  };

  deleteTwitterUN = (twitObj) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, twitObj.id, twitObj._id);
    // let arrWidgetNames = [];
    // let data = this.state.widgetListData.filter(x => {
    //   if (x.uid === twitObj.id && x.pid === twitObj._id) {
    //     return x;
    //   }
    // });
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (data && data.length > 0) {
        //   data.map((x) => {
        //     arrWidgetNames.push(x.wdsc);
        //   });
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteUNorTag(twitObj);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  //Instagram post
  //Create
  createInstagram = () => {
    let { un, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages(); that.forceUpdate();
    }
    else {
      let obj = {
        un: un,
        rmk: rmk
      };
      this.props.createInstaPostInt(obj);
      this.setState({
        islstIntLoading: true
      });
      this.initState();
    }
  }

  //delete
  deleteInstagram = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteInstaPost(_id);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  createInstaPostInt = (obj) => {
    this.props.createInstaPostInt(obj);
    this.setState({
      islstIntLoading: true
    });
    this.initState();
  }

  deleteInstaPostInt = (obj) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, obj._id, obj.pgid);
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteInstaPostInt(obj);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  //Google post
  //Create
  createGMBPage = (obj) => {
    this.setState({
      islstIntLoading: true
    });
    this.props.createGMBPostIntIA(obj);
    this.state.hideShowDrp = false;
    this.state.searchGMBPG = '';
    this.setState(this.state);
  }

  //delete
  deletePage = (obj) => {
    // let data = this.state.widgetListData.filter(x => x._id === obj._id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (data && data.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{data[0].data.toString()}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteGGLPostIntIA(obj);
                this.setState({
                  islstIntLoading: true
                });
                onClose();
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  deleteGMB = async (id) => {
    // let data = this.state.widgetListData.filter(x => x._id === id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (data && data.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{data[0].data.toString()}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteGGLPostInt(id);
                this.setState({
                  isList: false,
                  islstIntLoading: true
                }); onClose();
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Google Review
  //Update
  createGMBPageReview = (obj) => {
    this.setState({
      islstIntLoading: true
    });
    this.props.createGGLReviewIntIA(obj);
  }

  //Delete
  deletePageReview = (obj) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, obj._id, obj.name);
    // let arrWidgetNames = [];
    // let data = this.state.widgetListData.filter(x => {
    //   if (x.uid === obj._id && x.pid === obj.name) {
    //     return x;
    //   }
    // });
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (data && data.length > 0) {
        //   data.map((x) => {
        //     arrWidgetNames.push(x.wdsc);
        //   });
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteGGLReviewIntIA(obj);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  deleteGMBReview = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteGGLReviewInt(_id);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  syncLastestPages = (id) => {
    this.setState({
      islstIntLoading: true
    });
    this.props.syncLastestPages(id);
  }

  handleStateChangeDrpDOWN = (e, name) => {
    if (name === 'lng') {
      this.setState({ lng: e.value });
    } else if (name === 'tgOption') {
      this.setState({ tgOption: e.value });
    }
    else {
      this.setState({ hsTobj: e.value.toString() });
    }
  }

  //Google place
  createGooglePlace = async () => {
    let { place_id, rmk, lng } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages(); that.forceUpdate();
    }
    else {
      let obj = {
        pi: place_id,
        lng: lng,
        rmk: rmk,
        widgetById: this.props.widgetById,
        _id: this.props.allProps.location.query.id,
        cn: this.props.allProps.location.query.cn
      };
      this.props.createGooglePlace(obj);
      this.initState();
      this.setState({
        islstIntLoading: true
      });
    }
  }

  deleteGooglePlace = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, _id);
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              {/* <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p> */}
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => {
        //           browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist');
        //           onClose();
        //         }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteGooglePlace(_id);
                  onClose();
                  this.setState({
                    islstIntLoading: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  //Search by app
  handleSearchState = (e) => {
    this.setState({ searchByApp: e.target.value });
  }

  //capterra review
  createCapterra = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        url: curl,
        rmk: rmk
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createCapterra(obj);
      this.initState();
    }
  }

  deleteCapterra = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteCapterra(_id);
                  onClose();
                  this.setState({
                    islstIntLoading: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  syncReviews = (id) => {
    this.props.syncReviews(id);
  }

  //rss feed
  createRSS = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        url: curl,
        rmk: rmk
      };
      this.props.createRSS(obj);
      this.initState();
      this.setState({
        islstIntLoading: true
      });
    }
  }

  deleteRSS = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteRSS(_id);
                  onClose();
                  this.setState({
                    islstIntLoading: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  //tumblr feed
  createTumblr = () => {
    let { un, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        un: un,
        rmk: rmk
      };
      this.props.createTumblr(obj);
      this.initState();
      this.setState({
        islstIntLoading: true
      });
    }
  }

  deleteTumblr = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteTumblr(_id);
                  onClose();
                  this.setState({
                    islstIntLoading: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  createWebhook = () => {
    let { rmk, ak, urn } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        _id: this.state._id,
        rmk: rmk,
        ak: ak,
        urn: urn,
        inm: this.state.in
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createWebhook(obj);
      this.initState();
    }
  }

  deleteWebhook = (obj) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, obj.id, '');
    // let data = this.state.widgetListData.filter(x => x._id === obj._id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteWebhook(obj);
                  onClose();
                  this.setState({
                    islstIntLoading: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  handleDataSourceForIntegration = (intID, pgid, checked, objCountParams, objInt) => {
    localStorage.setItem('W_LOAD_DATA', true);
    let _id = '', wdsc = '', cn = '';
    if (this.props.widgetById) {
      _id = this.props.widgetById._id, wdsc = this.props.widgetById.wdsc, cn = this.props.widgetById.cn;
    }
    //checked==true then new datasourse push in to state.
    if (checked === true) {
      this.state.widgetListData = [...this.state.widgetListData, {
        'uid': intID,
        'cn': cn,
        'rmk': objCountParams.rmk,
        'url': '',
        'dn': objCountParams.dn,
        'pid': pgid,
        'wdsc': wdsc || this.props.state.wdsc,
        'wdid': _id
      }];
      this.setState(this.state);
    } else {
      //checked==false then splice object into state by pid, uid and widget id.
      this.state.widgetListData.filter((x, i) => {
        if (
          x.uid == intID &&
          x.pid == pgid &&
          x.wdid == _id
        ) {
          this.state.widgetListData.splice(i, 1);
        }
      });
    }
    this.setState(this.state);
    this.props.handleDataSource(intID, pgid, checked, objCountParams, objInt);
  }

  //Booking review
  createBooking = () => {
    let { curl, rmk } = this.state;
    let that = this;
    let hln;//HOTAL LOCATION
    let htn;//HOTAL NAME
    let name = curl.split('?');
    let url = name[0];
    name = name[0].split('/');
    let count = name.length;
    hln = name[count - 2];
    htn = name[count - 1].split('.');
    htn = htn[0];
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        hln: hln,
        htn: htn,
        rmk: rmk,
        url: url,
        orgurl: curl,
        widgetById: this.props.widgetById,
        _id: this.props.allProps.location.query.id,
        cn: this.props.allProps.location.query.cn
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createBooking(obj);
      this.initState();
    }
  }

  deleteBooking = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteBooking(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Booking review
  createTripAdvisor = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createTripAdvisor(obj);
      this.initState();
    }
  }

  deleteTripAdvisor = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                  <span className="nf-btn-span">Cancel</span>
                </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteTripAdvisor(_id);
                  onClose();
                  this.setState({
                    islstIntLoading: true,
                    isIntegration: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
        // }
      }
    });
  }

  //Trustpilot review
  createTrustpilot = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createTrustpilot(obj);
      this.initState();
    }
  }

  deleteTrustpilot = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteTrustpilot(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Airbnb review
  createAirbnb = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createAirbnb(obj);
      this.initState();
    }
  }

  deleteAirbnb = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteAirbnb(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Yelp review
  createYelp = () => {
    let { ak, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        ak: ak
      };
      this.setState({
        // islstIntLoading: true,
        isIntegration: true
      });
      this.props.createYelp(obj);
      this.initState();
    }
  }

  deleteYelp = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteYelp(_id);
                  onClose();
                  this.setState({
                    islstIntLoading: true,
                    isIntegration: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  //Hotels review
  createHotels = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createHotels(obj);
      this.initState();
    }
  }

  deleteHotels = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteHotels(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Etsy review
  createEtsy = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createEtsy(obj);
      this.initState();
    }
  }

  deleteEtsy = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteEtsy(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Houzz review
  createHouzz = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createHouzz(obj);
      this.initState();
    }
  }

  deleteHouzz = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteHouzz(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Edmunds review
  createEdmunds = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createEdmunds(obj);
      this.initState();
    }
  }

  deleteEdmunds = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteEdmunds(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //DealerRater review
  createDealerRater = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createDealerRater(obj);
      this.initState();
    }
  }

  deleteDealerRater = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteDealerRater(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //OpenTable review
  createOpenTable = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createOpenTable(obj);
      this.initState();
    }
  }

  deleteOpenTable = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteOpenTable(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //eBay review
  createeBay = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createeBay(obj);
      this.initState();
    }
  }

  deleteeBay = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteeBay(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //BBB review
  createBBB = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createBBB(obj);
      this.initState();
    }
  }

  deleteBBB = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteBBB(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Amzon review
  createAmzon = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createAmzon(obj);
      this.initState();
    }
  }

  deleteAmzon = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteAmzon(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //G2 review
  createG2 = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createG2(obj);
      this.initState();
    }
  }

  deleteG2 = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteG2(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Aliexpress review
  createAliexpress = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createAliexpress(obj);
      this.initState();
    }
  }

  deleteAliexpress = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteAliexpress(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //GooglePlay review
  createGooglePlay = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createGooglePlay(obj);
      this.initState();
    }
  }

  deleteGooglePlay = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteGooglePlay(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //AppleAPP review
  createAppleAPP = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createAppleAPP(obj);
      this.initState();
    }
  }

  deleteAppleAPP = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteAppleAPP(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //AppSumo review
  createAppSumo = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        url: curl
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createAppSumo(obj);
      this.initState();
    }
  }

  deleteAppSumo = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteAppSumo(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  //Common Function for delete popup and display connected widget name
  commonFNForDeletePopUpMsg = (widgetList, _id, pgid) => {
    let arrNames = [];
    let arrWidID = [];
    widgetList.filter(x => {
      if (arrWidID.indexOf(x.wdid) === -1) {
        if (pgid && x.uid === _id && pgid == x.pid) {
          arrWidID.push(x.wdid);
          arrNames.push(x.wdnm);
        } else if (!pgid && x.uid === _id) {
          arrWidID.push(x.wdid);
          arrNames.push(x.wdnm);
        }
      }
    });
    return arrNames;
  }


  // commonFNForDeletePopUpMsg = (uid) => {
  //   let arrWidgetNames = [];
  //   let grpBy = this.groupBy(
  //     this.state.widgetListData.filter(x => x.cn == this.props.allProps.location.query.cn),
  //     'wdid',
  //     uid
  //   );
  //   if (Object.keys(grpBy) && Object.keys(grpBy).length > 0) {
  //     for (const key in grpBy) {
  //       const element = grpBy[key].filter(x => {
  //         if (x) {
  //           return x;
  //         }
  //       });
  //       arrWidgetNames.push(element[0]);
  //     }
  //   }
  //   return arrWidgetNames;
  // }

  closeModalData = () => {
    this.state.cptntxt = '';
    this.state.adcr = '0';
    this.state.msg = '';
    this.state.un = '';
    this.state.isAddnewRec = true;
    this.state.rtxt = '';
    this.state.wbstlnk = '';
    this.state.wbstlg1 = '';
    this.state.piu = '';
    this.state.piu1 = '';
    this.state.wbstlg = '';
    this.state.fuid = '';
    this.state.openCloseData = false;
    this.setState(this.state);
  }

  editReview = (obj) => {
    this.setState({
      un: obj.un,
      styp: obj.styp ? obj.styp : '',
      pu: obj.pu ? obj.pu : '',
      msg: obj.msg,
      isAddnewRec: false,
      rtxt: obj.rtxt,
      piu: obj.piu,
      rtng: obj.rtng ? obj.rtng.toString() : '1',
      fuid: obj._id,
      cptntxt: obj.cptntxt,
      pgid: obj.pgid,
      wbstlnk: obj.wbstlnk,
      wbstlg: this.validURL(obj.wbstlg) == true ? obj.wbstlg : '',
      openCloseData: true
    });
  }

  updateReview = (data, from) => {
    this.state.iconLoader = true;
    this.setState(this.state);
    if (from == 'iconUpload') {
      let obj = {
        _id: this.state.fuid,
        wbstlg: this.state.wbstlg1,
        piu: this.state.piu1,
        fuid: this.state.reviewFuid
      };
      this.state.pageNoReview = 1;
      this.state.reviewDataItems = [];
      this.state.totalCountOfData = 0;
      this.setState(this.state);
      this.props.updateReview(obj);
    } else if (from == 'updateBtn') {
      this.state.reviewDataItems.filter(x => {
        if (x._id == data) {
          x.cptntxt = this.state.cptntxt;
          x.wbstlnk = this.state.wbstlnk;
          x.wbstlg = this.state.wbstlg;
          x.pu = this.state.pu;
          x.styp = this.state.styp;
          x.piu = this.state.piu;
          x.un = this.state.un;
          x.rtng = this.state.rtng;
          x.msg = this.state.msg;
          x.rtxt = this.state.rtxt;
          x.pgid = this.state.pgid;
        }
        return x;
      });
      let obj = {
        _id: this.state.fuid,
        cptntxt: this.state.cptntxt,
        wbstlnk: this.state.wbstlnk,
        wbstlg: this.state.wbstlg,
        piu: this.state.piu,
        pu: this.state.pu,
        styp: this.state.styp,
        un: this.state.un,
        rtng: this.state.rtng,
        msg: this.state.msg,
        rtxt: this.state.rtxt,
        fuid: this.state.reviewFuid,
        pgid: this.state.pgid
      };
      this.state.iconLable = '';
      this.state.iconLable = '';
      if (from == 'updateBtn') {
        this.state.openCloseData = false;
        this.state.iconLoader = true;
        this.state.wbstlg = '';
        this.state.wbstlg1 = '';
        this.state.pu = '';
        this.state.styp = '';
        this.state.piu = '';
        this.state.piu1 = '';
        this.state.un = '';
        this.state.cptntxt = '';
        this.state.wbstlnk = '';
        this.state.rtng = '5';
        this.state.fuid = '';
        this.state.msg = '';
        this.state.rtxt = '';
        this.state.pageNoReview = 1;
        this.state.reviewDataItems = [];
        this.state.totalCountOfData = 0;
      }
      this.setState(this.state);
      this.props.updateReview(obj);
    }
    // console.log(data, '===data');
    // this.state.iconLoader = true;
    // this.setState(this.state);
    // this.state.reviewDataItems.filter(x => {
    //   if (x._id == data) {
    //     x.cptntxt = this.state.cptntxt;
    //     x.wbstlnk = this.state.wbstlnk;
    //     x.wbstlg = this.state.wbstlg1 ? this.state.wbstlg1 : this.state.wbstlg;
    //   }
    //   return x;
    // });
    // let obj = {
    //   _id: this.state.fuid,
    //   cptntxt: this.state.cptntxt,
    //   wbstlnk: this.state.wbstlnk,
    //   wbstlg: this.state.wbstlg1 ? this.state.wbstlg1 : this.state.wbstlg
    // };
    // this.state.iconLable = '';
    // if (from == 'updateBtn') {
    //   this.closeModalData();
    //   this.state.wbstlg = '';
    //   this.state.wbstlg1 = '';
    // }
    // this.setState(this.state);
    // this.props.updateReview(obj);
  }

  handleReviewImgChange = (file) => {
    //convert image in base64 file
    if (file && file.length > 0) {
      this.base64FileURL(file[0], (obj) => {
        //this.state.wbstlg = obj;
        if (this.state.imField == 'wbstlg') {
          this.state.wbstlg1 = obj;
          this.state.iconLable = file[0].name;
          this.setState(this.state);
        } else if (this.state.imField == 'piu') {
          this.state.piu1 = obj;
          this.state.iconLable = file[0].name;
          this.setState(this.state);
        }
      });
    }
  }

  //base64 file convert
  base64FileURL = (element, callback) => {
    let file = element;
    let reader = new window.FileReader();
    reader.onloadend = function (e) {
      callback(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  //Check interval for icrn record is true
  chkInterval = () => {
    timeInt = setInterval(async () => {
      let arrListen = [];
      let filterData = this.props.userIntegration.filter(x => x.inm == this.state.in);
      if (filterData.length > 0) {
        if (this.state.in === 'googlemybusiness') {
          filterData.filter(x => {
            if (x.d && x.d.lc && x.d.lc.length > 0) {
              let chkFil = x.d.lc.filter(y => y.ia == true && y.isListen === true);
              if (chkFil && chkFil.length > 0) {
                arrListen.push(chkFil[0]);
              }
            }
          });
          if (arrListen.length > 0) {
            this.state.openClose = true;
            this.state.isListening = true;
            this.opCLIntModel(this.state);
          } else {
            clearInterval(timeInt);
            this.state.isCallInterVal = false;
            this.setState(this.state);
          }
        } else if (this.state.in === 'facebook') {
          filterData.filter(x => {
            if (x.d && x.d.fb_page && x.d.fb_page.length > 0) {
              let chkFil = x.d.fb_page.filter(y => y.ia == true && y.isListen === true);
              if (chkFil && chkFil.length > 0) {
                arrListen.push(chkFil[0]);
              }
            }
          });
          if (arrListen.length > 0) {
            this.state.openClose = true;
            this.state.isListening = true;
            this.opCLIntModel(this.state);
          } else {
            clearInterval(timeInt);
            this.state.isCallInterVal = false;
            this.setState(this.state);
          }
        } else {
          filterData.filter(x => {
            if (x.d && x.d.isListen === true) {
              arrListen.push(x);
            }
          });
          if (arrListen.length > 0) {
            this.state.openClose = true;
            this.state.isListening = true;
            this.opCLIntModel(this.state);
          } else {
            clearInterval(timeInt);
            this.state.isCallInterVal = false;
            this.setState(this.state);
          }
        }
      } else {
        clearInterval(timeInt);
        this.state.isAPICall = false;
        this.setState(this.state);
      }
    }, 3000);
    // let intFilterCount1 = 0;
    // this.props.userIntegration.filter(x => {
    //   if (x.d.isListen === true) {
    //     intFilterCount1 += 1;
    //   }
    // });
    // if (intFilterCount1 === 0) {
    //   localStorage.setItem('W_LOAD_DATA', false);
    //   this.state.isAPICall = false;
    //   this.state.islstIntLoading = false;
    //   this.setState(this.state);
    // }
    // else {
    //   timeInt = setInterval(async () => {
    //     if (this.props.state.tabIndex != 4 || this.props.state.intTabIndex == 1) {
    //       localStorage.setItem('W_LOAD_DATA', false);
    //       clearInterval(timeInt);
    //     }
    //     else {//Check integration if isListen=true then Set loader in iframe and call get Integraion API.
    //       let intFilterCount2 = 0;
    //       this.props.userIntegration.filter(x => {
    //         if (x.inm == 'googlereview') {
    //           x.d.lc.filter((y) => {
    //             if (y.isListen === true && y.ia === true) {
    //               intFilterCount2 += 1;
    //             }
    //           });
    //         } else if (x.d.isListen === true) {
    //           intFilterCount2 += 1;
    //         }
    //       });
    //       if (intFilterCount2 > 0) {
    //         let obj = {
    //           in: this.props.userIntegration[0].inm,
    //           isListening: true
    //         };
    //         this.opCLIntModel(obj);
    //       }
    //       else {
    //         //isListen=false then remove Loader and Set false value in Localstorage.
    //         //Clear 30 Second Interval
    //         localStorage.setItem('W_LOAD_DATA', false);
    //         clearInterval(timeInt);
    //         this.state.isAPICall = false;
    //         this.state.islstIntLoading = false;
    //         this.setState(this.state);
    //       }
    //     }
    //   }, 3000);
    // }
  }

  intInterValFn = () => {
    this.state.isCallInterVal = true;
    this.chkInterval();
    this.setState(this.state);
  }

  //Open Close Filter DropDown
  openCloseFilter = (id) => {
    if (!this.state.isOpenCloseFilter == true) {
      this.state.twitterUNid = id;
    }
    else {
      this.state.twitterUNid = '';
    }
    this.state.isOpenCloseFilter = !this.state.isOpenCloseFilter;
    this.setState(this.state);
  }

  //Update Filter CheckBox
  updateFilter = (_id, pageObj, e, isDSI, objCountParams) => {
    this.state[e.target.name] = e.target.checked;
    this.state.isFromInt = 'twitterpost';
    objCountParams[e.target.name] = e.target.checked;
    objCountParams.isFromInt = 'twitterpost';
    this.setState(this.state);
    this.handleDataSourceForIntegration(
      _id,
      pageObj._id,
      isDSI,
      objCountParams
    );
    this.props.updateFilter({
      [e.target.name]: e.target.checked,
      _id: _id,
      unqid: this.props.widgetById.unqid,
      id: pageObj._id
    });
  }

  //hide show integration table
  hideShowIntegration = () => {
    this.state.isHideShowInt = !this.state.isHideShowInt;
    this.setState(this.state);
  }

  deleteImage = (id, iu) => {
    this.state.iconLoader = true;
    this.setState(this.state);
    let obj = {
      id: id, wbstlnk: iu
    };
    this.props.deleteImage(obj);
  }

  uploadIconfile = (id) => {
    if (this.state.imField == 'wbstlg' && this.state.wbstlg1 && this.validURL(this.state.wbstlg1) == false) {
      this.updateReview(id, 'iconUpload');
    } else if (this.state.imField == 'piu' && this.state.piu1 && this.validURL(this.state.piu1) == false) {
      this.updateReview(id, 'iconUpload');
    }
  }

  setIconImageURL = (iu) => {
    if (this.state.imField == 'wbstlg') {
      this.state.wbstlg = iu;
      this.state.openCloseIconModel = false;
      this.setState(this.state);
    } else if (this.state.imField == 'piu') {
      this.state.piu = iu;
      this.state.openCloseIconModel = false;
      this.setState(this.state);
    }

    // let obj = {
    //   id: this.state.fuid,
    //   cptntxt: this.state.cptntxt,
    //   wbstlnk: this.state.wbstlnk,
    //   wbstlg: iu
    // };
    // this.updateReview(this.state.fuid);
    //this.props.setIconImageURL(obj);
  }

  validURL = (str) => {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  iconModelCont = () => {
    return (
      <div className="modal-body wdgt-icon-setting">
        <div className="mdl-icon-upload mdl-icon-upload-custom">
          {/* <input className="input_files" id="review_img_upload" onChange={(e) => this.handleReviewImgChange(e.target.files[0])} type="file" name="file" />
          <input className="nf-btn nf-btn-default  nf-btn-min15x" type='button' value='UPLOAD'
            onClick={() => this.uploadIconfile(this.state.fuid)} /> */}
          <ImageUploader
            className='simpple'
            fileContainerStyle={{ padding: 0, display: 'block', background: 'rgba(0,0,0,0)', WebkitBoxShadow: 'none', boxShadow: 'none', margin: 0 }}
            buttonClassName=''
            buttonStyles={{}}
            withIcon={false}
            withLabel={true}
            label={this.state.iconLable ? this.state.iconLable : ''}
            labelStyles={{ float: 'right' }}
            buttonText='Browse'
            singleImage={true}
            onChange={this.handleReviewImgChange}
            imgExtension={['.jpg', '.jpeg', '.png', '.svg', '.gif']}
            maxFileSize={5242880} />
          <input className="nf-btn nf-btn-default nf-btn-min15x nf-btn-minW" type='button' value='UPLOAD'
            onClick={() => this.uploadIconfile(this.state.fuid)} />
        </div>
        {this.state.iconLoader == true ?
          <ContentLoader
            height={450}
            width={700}
            speed={2}
            primaryColor="#eceef4"
            secondaryColor="#fff">
            <rect x="20" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="110" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="200" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="290" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="380" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="470" y="25" rx="0" ry="0" width="75" height="75" />
            <rect x="560" y="25" rx="0" ry="0" width="75" height="75" />

            <rect x="20" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="110" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="200" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="290" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="380" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="470" y="115" rx="0" ry="0" width="75" height="75" />
            <rect x="560" y="115" rx="0" ry="0" width="75" height="75" />

            <rect x="20" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="110" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="200" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="290" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="380" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="470" y="205" rx="0" ry="0" width="75" height="75" />
            <rect x="560" y="205" rx="0" ry="0" width="75" height="75" />

            <rect x="20" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="110" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="200" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="290" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="380" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="470" y="295" rx="0" ry="0" width="75" height="75" />
            <rect x="560" y="295" rx="0" ry="0" width="75" height="75" />
          </ContentLoader> :
          <div className="wdgt-iconmodal-block">
            {
              this.props.iconImages && this.props.iconImages.map((val, key) => {
                return (
                  <div className="icon-gallery-item" key={key}>
                    <div className="icon-gallery-box">
                      <span className="tbl-action-dlt action-dlt-icongallery"
                        onClick={() => this.deleteImage(val._id, val.iu)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                          <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                            <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                            <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                          </g>
                        </svg>
                      </span>
                      <img src={val.iu} style={{ height: '150px', width: '150px' }} alt="icon"
                        onClick={() => this.setIconImageURL(val.iu)} />
                    </div>
                  </div>
                );
              })
            }
          </div>}

      </div>
    );
  }

  closeIconModel = () => {
    this.setState({ openCloseIconModel: false });
  }

  openIconModel = (id, imField) => {
    this.setState({ openCloseIconModel: true, fuid: id, iconLoader: false, imField: imField });
  }

  deleteCustomReview = (id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteCustomReview(id);
                  onClose();
                  this.setState({
                    islstIntLoading: true,
                    isIntegration: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }
  // //add//remove dataSource
  // handleDataSource = (id, pid, chkBox) => {
  //   if (this.props.queryParam.id) {
  //     let obj = {
  //       uid: id,
  //       _id: this.props.queryParam.id,
  //       //fn: this.state.fn,
  //       cn: this.props.queryParam.cn
  //     };
  //     if (pid) {
  //       obj.pid = pid;
  //     }
  //     if (chkBox == true) {
  //       this.props.addDataSrc(obj);
  //     }
  //     else if (chkBox == false) {
  //       this.props.delDataSrc(obj);
  //     }
  //   }
  //   else{

  //   }
  // }
  //AppleAPP review
  createYouTubeVideoGallery = () => {
    let { pi, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        rmk: rmk,
        pi: pi
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createYouTubeVideoGallery(obj);
      this.initState();
    }
  }

  deleteYouTubeVideoGallery = (_id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, _id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteYouTubeVideoGallery(_id);
                  onClose();
                  this.setState({
                    islstIntLoading: true,
                    isIntegration: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  createStamped = () => {
    let { puak, prak, sh, rmk, stpd } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        puak: puak,
        prak: prak,
        sh: sh,
        rmk: rmk,
        url: window.location.origin,
        stpd: stpd
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createStamped(obj);
      this.initState();
    }
  }

  deleteStamped = (_id) => {
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        // else {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.props.deleteStamped(_id);
                onClose();
                this.setState({
                  islstIntLoading: true,
                  isIntegration: true
                });
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
        // }
      }
    });
  }

  createTumblrPostInt = (obj) => {
    this.props.createTumblrPostInt(obj);
    this.setState({
      islstIntLoading: true
    });
    this.initState();
  }

  deleteTumblrPostInt = (obj) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, obj._id, obj.pgid);
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteTumblrPostInt(obj);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  disableOnCreateInt = () => {
    this.state.isCreatingIntegration = true;
    this.setState(this.state);
  }

  createTwitterTestimonial = () => {
    let { curl, rmk } = this.state;
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        curl: curl,
        rmk: rmk,
      };
      this.setState({
        islstIntLoading: true,
        isIntegration: true
      });
      this.props.createTwitterTestimonial(obj);
      this.initState();
    }
  }

  deleteTwitterTestimonial = (id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteTwitterTestimonial(id);
                  this.setState({
                    islstIntLoading: true
                  });
                  onClose();
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  /////////////////////////////////////////////////// End Integration Method //////////////////////////////////////////////////////////
  removeImage = () => {
    // let obj = {
    //   id: this.state.fuid
    // };
    this.state.wbstlg = '';
    this.state.wbstlg1 = '';
    this.setState(this.state);
    //this.props.removeImage(obj);
  }

  removeReviewImage = () => {
    // let obj = {
    //   id: this.state.fuid
    // };
    this.state.piu = '';
    this.state.piu1 = '';
    this.setState(this.state);
    //this.props.removeImage(obj);
  }

  createCustomReview = () => {
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    } else {
      let obj = {
        rmk: that.state.rmk,
        curl: this.state.curl
      };
      that.props.createCustomReview(obj);
    }
    that.initState();
  }

  openAddDataModal = () => {
    this.state.openCloseData = true;
    this.state.isAddnewRec = true;
    this.setState(this.state);
  }

  copyEndpoint = (value) => {
    copy(value, { debug: true });
    this.state.epURL = value;
    this.setState(this.state);
    if (!toast.isActive(this.toastId)) {
      this.toastId = toast.success('Endpoint copied');
    }
    return;
  }

  renderIntData = () => {
    this.validator.purgeFields();
    this.ytValidator.purgeFields();
    return <div>
      {this.state.in == 'airbnb' &&
        <Airbnb

          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createAirbnb={this.createAirbnb}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteAirbnb={this.deleteAirbnb}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'aliexpressreview' &&
        <Aliexpress
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createAliexpress={this.createAliexpress}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteAliexpress={this.deleteAliexpress}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'amazon' &&
        <Amzon
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createAmzon={this.createAmzon}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteAmzon={this.deleteAmzon}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'appsumo' &&
        <AppSumo
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createAppSumo={this.createAppSumo}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteAppSumo={this.deleteAppSumo}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'appleapp' &&
        <AppleApp
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createAppleAPP={this.createAppleAPP}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteAppleAPP={this.deleteAppleAPP}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'bbb' &&
        <BBB
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createBBB={this.createBBB}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteBBB={this.deleteBBB}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'booking' &&
        <Booking
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createBooking={this.createBooking}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteBooking={this.deleteBooking}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'capterra' &&
        <Capterra
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createCapterra={this.createCapterra}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteCapterra={this.deleteCapterra}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
          syncReviews={this.syncReviews}
          intInterValFn={this.intInterValFn}
        />
      }
      {this.state.in == 'twittertestimonial' &&
        <TwitterTestimonial
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createTwitterTestimonial={this.createTwitterTestimonial}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteTwitterTestimonial={this.deleteTwitterTestimonial}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
          syncReviews={this.syncReviews}
          intInterValFn={this.intInterValFn}
        />
      }
      {this.state.in == 'customcollectorreview' &&
        <CustomCollectorReview
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'customreview' &&
        <CustomReview
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createCustomReview={this.createCustomReview}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteCustomReview={this.deleteCustomReview}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'custom' &&
        <CustomWebhook
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createCustomWebhook={this.createCustomWebhook}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteCustomWebhook={this.deleteCustomWebhook}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openCustomWBPanel={this.openCustomWBPanel}
          copyEndpoint={this.copyEndpoint}
        />
      }
      {this.state.in == 'dealerrater' &&
        <DealerRater
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createDealerRater={this.createDealerRater}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteDealerRater={this.deleteDealerRater}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'edmunds' &&
        <Edmunds
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createEdmunds={this.createEdmunds}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteEdmunds={this.deleteEdmunds}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'etsy' &&
        <Etsy
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createEtsy={this.createEtsy}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteEtsy={this.deleteEtsy}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'facebookpost' &&
        <FacebookPost
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          handleIsActive={this.handleIsActive}
          closeModal={this.closeModal}
          userIntegration={this.props.userIntegration}
          createFBPage={this.createFBPage}
          deleteFBList={this.deleteFBList}
          deleteFB={this.deleteFB}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          handleDropdown={this.handleDropdown}
          hideShowDrp={this.state.hideShowDrp}
          intDropUniq={this.state.intDropUniq}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          handleStateChangeInt={this.handleStateChangeInt}
          disableOnCreateInt={this.disableOnCreateInt}
        />
      }
      {this.state.in == 'facebook' &&
        <FacebookReview
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          handleIsActive={this.handleIsActive}
          closeModal={this.closeModal}
          userIntegration={this.props.userIntegration}
          createFBPageReview={this.createFBPageReview}
          deleteFBListReview={this.deleteFBListReview}
          deleteFBReview={this.deleteFBReview}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          handleDropdown={this.handleDropdown}
          hideShowDrp={this.state.hideShowDrp}
          intDropUniq={this.state.intDropUniq}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          openReviewModel={this.openReviewModel}
          intInterValFn={this.intInterValFn}
          disableOnCreateInt={this.disableOnCreateInt}
        />
      }
      {this.state.in == 'g2review' &&
        <G2
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createG2={this.createG2}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteG2={this.deleteG2}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'google' &&
        <GooglePlace
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          profile={this.props.profile}
          closeModal={this.closeModal}
          createGooglePlace={this.createGooglePlace}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteGooglePlace={this.deleteGooglePlace}
          validator={this.validator}
          loading={this.props.isIntLoader}
          handleStateChangeDrpDOWN={this.handleStateChangeDrpDOWN}
          handleIsActive={this.handleIsActive}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
          intInterValFn={this.intInterValFn}
        />
      }
      {this.state.in == 'googleplay' &&
        <GooglePlay
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createGooglePlay={this.createGooglePlay}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteGooglePlay={this.deleteGooglePlay}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'googlepost' &&
        <GooglePost
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          handleIsActive={this.handleIsActive}
          userIntegration={this.props.userIntegration}
          loading={this.props.isIntLoader}
          handleDropdown={this.handleDropdown}
          hideShowDrp={this.state.hideShowDrp}
          profile={this.props.profile}
          intDropUniq={this.state.intDropUniq}
          createGGLInt={this.createGGLInt}
          createGMBPostIntIA={this.createGMBPostIntIA}
          deleteGGLPostInt={this.deleteGGLPostInt}
          deleteGGLPostIntIA={this.deleteGGLPostIntIA}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
        />
      }
      {this.state.in == 'googlemybusiness' &&
        <GoogleReview
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          profile={this.props.profile}
          handleIsActive={this.handleIsActive}
          userIntegration={this.props.userIntegration}
          loading={this.props.isIntLoader}
          handleDropdown={this.handleDropdown}
          hideShowDrp={this.state.hideShowDrp}
          intDropUniq={this.state.intDropUniq}
          createGMBPageReview={this.createGMBPageReview}
          syncLastestPages={this.syncLastestPages}
          handleStateChangeInt={this.handleStateChangeInt}
          deletePageReview={this.deletePageReview}
          deleteGMBReview={this.deleteGMBReview}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          openReviewModel={this.openReviewModel}
          intInterValFn={this.intInterValFn}
          disableOnCreateInt={this.disableOnCreateInt}
        />
      }
      {this.state.in == 'hotels' &&
        <Hotels
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createHotels={this.createHotels}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteHotels={this.deleteHotels}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'houzz' &&
        <Houzz
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createHouzz={this.createHouzz}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteHouzz={this.deleteHouzz}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'instagrampost' &&
        <InstaPost
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createInstagram={this.createInstagram}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteInstagram={this.deleteInstagram}
          createInstaPostInt={this.createInstaPostInt}
          deleteInstaPostInt={this.deleteInstaPostInt}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          handleIsActive={this.handleIsActive}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          disableOnCreateInt={this.disableOnCreateInt}
        />
      }
      {this.state.in == 'opentable' &&
        <OpenTable
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createOpenTable={this.createOpenTable}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteOpenTable={this.deleteOpenTable}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'rsspost' &&
        <RSS
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createRSS={this.createRSS}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteRSS={this.deleteRSS}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
        />
      }
      {this.state.in == 'tripadvisor' &&
        <TripAdvisor
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createTripAdvisor={this.createTripAdvisor}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteTripAdvisor={this.deleteTripAdvisor}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
          intInterValFn={this.intInterValFn}
        />
      }
      {this.state.in == 'trustpilot' &&
        <Trustpilot
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createTrustpilot={this.createTrustpilot}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteTrustpilot={this.deleteTrustpilot}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'tumblrpost' &&
        <Tumblr
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          profile={this.props.profile}
          closeModal={this.closeModal}
          createTumblr={this.createTumblr}
          handleStateChangeInt={this.handleStateChangeInt}
          createTumblrPostInt={this.createTumblrPostInt}
          deleteTumblrPostInt={this.deleteTumblrPostInt}
          userIntegration={this.props.userIntegration}
          deleteTumblr={this.deleteTumblr}
          validator={this.validator}
          loading={this.props.isIntLoader}
          handleIsActive={this.handleIsActive}
          twitterOauth={this.props.twitterOauth}
          deleteTwitterUN={this.deleteTwitterUN}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          disableOnCreateInt={this.disableOnCreateInt}
        />
      }
      {this.state.in == 'twitterpost' &&
        <TwitterPost
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          profile={this.props.profile}
          closeModal={this.closeModal}
          createTwitterUN={this.createTwitterUN}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteTwitter={this.deleteTwitter}
          validator={this.validator}
          openCloseFilter={this.openCloseFilter}
          updateFilter={this.updateFilter}
          loading={this.props.isIntLoader}
          handleIsActive={this.handleIsActive}
          twitterOauth={this.createOAuth}
          deleteTwitterUN={this.deleteTwitterUN}
          handleStateChangeDrpDOWN={this.handleStateChangeDrpDOWN}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
        />
      }
      {this.state.in == 'yelp' &&
        <Yelp
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createYelp={this.createYelp}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteYelp={this.deleteYelp}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
          props={this.props}
        />
      }
      {this.state.in == 'ebay' &&
        <Ebay
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createeBay={this.createeBay}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteeBay={this.deleteeBay}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
        />
      }
      {this.state.in == 'youtubevideogallery' &&
        <YouTubeVideoGallery
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          profile={this.props.profile}
          closeModal={this.closeModal}
          createYouTubeVideoGallery={this.createYouTubeVideoGallery}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteYouTubeVideoGallery={this.deleteYouTubeVideoGallery}
          validator={this.validator}
          loading={this.props.isIntLoader}
          handleIsActive={this.handleIsActive}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
        />
      }
      {this.state.in == 'stamped' &&
        <Stamped
          openClose={this.state.openClose}
          data={this.state}
          closeModal={this.closeModal}
          handleIsActive={this.handleIsActive}
          createStamped={this.createStamped}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteStamped={this.deleteStamped}
          validator={this.validator}
          loading={this.props.isIntLoader}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
        />
      }
      {this.state.in == 'importreviews' &&
        <ImportReviews
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createReview={this.createReview}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          userIntegration={this.props.userIntegration}
          deleteImportReview={this.deleteImportReview}
          validator={this.validator}
          loading={this.props.isIntLoader}
          CSVfile={this.CSVfile}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
          openAddReviewModel={this.openAddReviewModel}
        />
      }
      {this.state.t == 0 &&
        <Webhook
          openClose={this.state.openClose}
          state={this.props.state}
          data={this.state}
          closeModal={this.closeModal}
          createWebhook={this.createWebhook}
          webhookList={this.state.webhookList}
          handleIsActive={this.handleIsActive}
          handleStateChangeInt={this.handleStateChangeInt}
          copyEndpoint={this.copyEndpoint}
          userIntegration={this.props.userIntegration}
          deleteWebhook={this.deleteWebhook}
          validator={this.validator}
          loading={this.props.isIntLoader}
          CSVfile={this.CSVfile}
          profile={this.props.profile}
          arrDataSource={arrDataSource}
          handleDataSource={this.handleDataSourceForIntegration}
          hideShowDataSource={this.hideShowDataSource}
          hideShowIntegration={this.hideShowIntegration}
          openReviewModel={this.openReviewModel}
          openAddReviewModel={this.openAddReviewModel}
        />
      }
    </div>;
  }

  hideShowDataSource = (typ) => {
    this.state.openClose = !this.state.openClose;
    if (this.state.openClose == false) {
      this.state.isHideShowInt = false;
      this.state.searchByName = '';
    }
    if (typ == 'close') {
      this.opCLIntModel({ openClose: false });
      this.props.isOpenIntegrationModel();
      this.state.openCloseSideDataPanel = false;
      this.state.isLoaderForReviewDiv = false;
      this.state.pageNoReview = 0;
      this.state.reviewFuid = '';
      this.state.dnForEditRevie = '';
      this.setState(this.state);
      // this.state.isOpenDirectReviewModel
    } if (typ == 'back') {
      this.state.islstIntLoading = false;
    }
    this.setState(this.state);
    clearInterval(timeInt);
  }

  // hideDataSource = () => {
  //   console.log('call');
  //   this.state.openClose = false;
  //   this.state.isHideShowInt = false;
  //   this.state.searchByName = '';
  //   this.setState(this.state);
  //   this.props.isOpenIntegrationModel();
  //   clearInterval(timeInt);
  // }

  helpURL = (url) => {
    window.open(url, '_blank');
  }

  openReviewModel = (usInt) => {
    this.props.state.usIntObj.rmk = usInt.rmk;
    this.state.openCloseSideDataPanel = true;
    this.state.isLoaderForReviewDiv = true;
    this.state.pageNoReview = 1;
    this.state.in = usInt.inm;
    this.state.reviewFuid = usInt._id;
    this.state.dnForEditRevie = usInt.rmk;
    this.setState(this.state);
    let objPgn = {
      id: usInt._id,
      pn: 1,
      cl: 0,
      in: usInt.inm
    };
    if (usInt.inm == 'googlereview') {
      objPgn.pgid = usInt.d.filData.name;
      this.state.reviewPgId = usInt.d.filData.name;
      this.setState(this.state);
    }
    if (usInt.inm == 'facebook') {
      objPgn.pgid = usInt.d.filData.id;
      this.state.reviewPgId = usInt.d.filData.id;
      this.setState(this.state);
    }
    this.props.getReviews(objPgn);
  }

  openAddReviewModel = (usInt) => {
    this.state.openCloseSideDataPanel = true;
    this.state.isLoaderForReviewDiv = true;
    this.state.pageNoReview = 1;
    this.state.in = usInt.inm;
    this.state.isAddnewRec = true;
    this.state.openCloseData = true;
    this.state.reviewFuid = usInt._id;
    this.state.dnForEditRevie = usInt.rmk;
    this.setState(this.state);
    let objPgn = {
      id: usInt._id,
      pn: 1,
      cl: 0,
      in: usInt.inm
    };
    if (usInt.inm == 'googlereview') {
      objPgn.pgid = usInt.d.filData.name;
      this.state.reviewPgId = usInt.d.filData.name;
      this.setState(this.state);
    }
    if (usInt.inm == 'facebook') {
      objPgn.pgid = usInt.d.filData.id;
      this.state.reviewPgId = usInt.d.filData.id;
      this.setState(this.state);
    }
    this.props.getReviews(objPgn);
  }

  //get review with next page
  getReviewPaging = () => {
    this.state.pageNoReview = this.state.pageNoReview + 1;
    let objPgn = {
      id: this.state.reviewFuid,
      pn: this.state.pageNoReview,
      pgid: this.state.reviewPgId,
      cl: this.state.reviewDataItems.length,
      in: this.state.in
    };
    this.props.getReviews(objPgn);
  }

  closeDataPanel = () => {
    if (this.state.fuid == '') {
      this.state.openCloseData = false;
      this.state.openCloseSideDataPanel = false;
      this.state.cptntxt = '';
      this.state.wbstlnk = '';
      this.state.wbstlg1 = '';
      this.state.wbstlg = '';
      this.state.fuid = '';
      this.state.pageNoReview = 1;
      this.state.reviewDataItems = [];
      this.state.totalCountOfData = 0;
      this.setState(this.state);
    }
  }

  deleteReview = (id, fuid) => {
    let index = this.state.reviewDataItems.findIndex(x => x._id == id);
    var array = this.state.reviewDataItems;
    if (index > -1) {
      array.splice(index, 1);
    }
    let obj = {
      id: id,
      fuid: fuid
    };
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.state.reviewDataItems = array;
                this.state.totalCountOfData = this.state.totalCountOfData - 1;
                this.setState(this.state);
                this.props.deleteReview(obj);
                onClose();
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
      }
    });
  }

  handleInputchange = (state, value) => {
    if (state == 'rtng') { //for shopify
      this.state.rtng = value.value;
    } else if (state == 'styp') { //for shopify
      this.state.styp = value.value;
    }
    this.setState(this.state);
  }

  // closeDataCustomPanel = () => {
  //   this.state.openCloseSideCustomPanel = false;
  //   this.setState(this.state);
  // }

  // closeModalCustomData = () => {
  //   this.state.openCloseSideCustomData = false;
  //   this.setState(this.state);
  // }

  // openDataCustomPanel = () => {
  //   this.state.openCloseSideCustomData = true;
  //   this.setState(this.state);
  // }

  addCutomReview = () => {
    let that = this;
    if (!this.rtValidator.allValid()) {
      that.rtValidator.showMessages();
      that.forceUpdate();
    } else {
      let objCustom = {
        un: this.state.un,
        styp: this.state.styp,
        pu: this.state.pu,
        rtng: this.state.rtng,
        msg: this.state.msg,
        rtxt: this.state.rtxt,
        cptntxt: this.state.cptntxt,
        wbstlnk: this.state.wbstlnk,
        piu: this.state.piu,
        wbstlg: this.state.wbstlg,
        fa: this.state.in,
        fuid: this.state.reviewFuid,
        pn: 1,
        cl: 0,
        pgid: this.state.reviewFuid
      };
      console.log(this.state, '===this.state');
      this.props.addCutomReview(objCustom);
      this.state.cptntxt = '';
      this.state.openCloseData = false;
      this.state.pageNoReview = 1;
      this.state.reviewDataItems = [];
      this.state.totalCountOfData = 0;
      this.state.wbstlnk = '';
      this.state.wbstlg1 = '';
      this.state.wbstlg = '';
      this.state.styp = '';
      this.state.pu = '';
      this.state.piu1 = '';
      this.state.piu = '';
      this.state.fuid = '';
      this.state.un = '';
      this.state.rtng = '5';
      this.state.msg = '';
      this.state.rtxt = '';
      this.state.isAddnewRec = false;
      this.setState(this.state);
    }
  }

  downloadExcelData = () => {
    this.setState({
      isExcelDownload: true
    });
    this.props.downloadExcelData(this.state.reviewFuid);
  }

  //custom webhook
  //Close Slide panel
  closeCustomWBPanel = () => {
    this.state.openCloseCustomWBPanel = false;
    this.state.usIntId = '';
    this.setState(this.state);
    clearInterval(FieldInterval);
  }

  openCustomWBPanel = (fuid) => {
    this.state.openCloseCustomWBPanel = true;
    this.state.usIntId = fuid;
    this.setState(this.state);
    let objParams = {
      _id: fuid,
      id: this.props.widgetById._id
    };
    this.props.getCustomWBField(objParams);
  }

  intervalCustomFields = () => {
    clearInterval(FieldInterval);
    FieldInterval = setInterval(() => {
      let objParams = {
        _id: this.state.usIntId,
        id: this.props.widgetById._id
      };
      this.props.getCustomWBField(objParams);
    }, 5000);
  }

  createCustomWebhook = () => {
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    } else {
      that.props.createCustomWebhook({
        rmk: that.state.rmk,
        id: that.props.widgetById._id
      });
      that.state.rmk = '';
      that.setState(that.state);
    }
  }

  addCustomField = () => {
    this.props.addCustomField({
      custkeyword: this.state.custkeyword,
      custvalue: this.state.custvalue,
      fuid: this.state.usIntId,
      id: this.props.widgetById._id
    });
    this.state.custkeyword = '';
    this.state.custvalue = '';
    this.setState(this.state);
    //custkeyword custvalue
  }

  handleCustomFieldkey = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  deleteCustomField = (objKeys) => {
    objKeys.id = this.props.widgetById._id;
    this.props.deleteCustomField(objKeys);
  }

  updCustomField = () => {
    this.props.updCustomField({ fuid: this.state.usIntId });
  }

  deleteCustomWebhook = (id) => {
    let objParam = {
      _id: id,
      id: this.props.widgetById._id
    };
    let index = this.state.reviewDataItems.findIndex(x => x._id == id);
    var array = this.state.reviewDataItems;
    if (index > -1) {
      array.splice(index, 1);
    }
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1> Are you sure want to delete this record?</h1>
            <p>By clicking yes, you will lose the current  record.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => {
                this.state.reviewDataItems = array;
                this.state.totalCountOfData = this.state.totalCountOfData - 1;
                this.setState(this.state);
                this.props.deleteCustomWebhook(objParam);
                onClose();
              }}>
              Yes, Delete record
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              <span className="nf-btn-span">Cancel</span>
            </button>
          </div>
        );
      }
    });
  }

  openDirectReviewModel = (usInt) => {
    this.state.isOpenDirectReviewModel = true;
    this.setState(this.state);
    this.openReviewModel(usInt);
  }

  //createReview
  createReview = () => {
    let that = this;
    if (!this.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      // let obj = {
      //   base64: this.state.curl.base64,
      //   type: this.state.curl.type,
      //   rmk: this.state.rmk
      // };
      // const formData = new window.FormData();
      // // Update the formData object 
      // formData.append(
      //   'myfile',
      //   this.state.selectedFile,
      // );
      // formData.append(
      //   'remark',
      //   this.state.rmk
      // );
      const formData = new window.FormData();
      formData.append('remark', this.state.rmk);
      formData.append('type', 'widget');
      this.props.createImportReview(formData);
      this.initState();
      // document.getElementById('csvUploadFile').value = '';
    }
  }

  //deleteImportReview
  deleteImportReview = (id) => {
    let chkWidget = this.commonFNForDeletePopUpMsg(this.props.widgetList, id, '');
    // let arrWidgetNames = this.commonFNForDeletePopUpMsg(_id);
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        // if (arrWidgetNames && arrWidgetNames.length > 0) {
        //   return (
        //     <div className='custom-ui'>
        //       <h1>This data source is already in use!</h1>
        //       <p>Kindly disable this data-source from <b><i>{arrWidgetNames.join(', ')}</i></b> Widget first & After that, you can delete it.</p>
        //       <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
        //         onClick={() => { browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'wdlist'); onClose(); }}>
        //         Go to Widget
        //       </button>
        //       <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
        //         <span className="nf-btn-span">Cancel</span>
        //       </button>
        //     </div>
        //   );
        // }
        if (chkWidget && chkWidget.length > 0) {
          return (
            <div className='custom-ui'>
              <h1>This data source is already in use!</h1>
              <p>To delete, kindly disable it from widgets first: <b><i>{chkWidget.join(', ')}</i></b></p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
                onClick={() => {
                  // this.hideShowDataSource('close');
                  // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist');
                  onClose();
                }}>
                Close
              </button>
              {/* <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button> */}
            </div>
          );
        }
        else {
          return (
            <div className='custom-ui'>
              <h1> Are you sure want to delete this record?</h1>
              <p>By clicking yes, you will lose the current  record.</p>
              <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
                onClick={() => {
                  this.props.deleteImportReview(id);
                  onClose();
                  this.setState({
                    islstIntLoading: true,
                    isIntegration: true
                  });
                }}>
                Yes, Delete record
              </button>
              <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
                <span className="nf-btn-span">Cancel</span>
              </button>
            </div>
          );
        }
      }
    });
  }

  //get csv file
  CSVfile = (event) => {
    let obj = event.target.files[0];
    let type = obj.name.split('.');
    type = type[type.length - 1];
    if (type == 'csv') {
      this.state.selectedFile = event.target.files[0];
      this.state.curl = this.state.selectedFile;
      this.setState(this.state);
    }
    else { toast.info('Only CSV format allowed!'); document.getElementById('csvUploadFile').value = ''; }
    // let type = obj.name.split('.');
    // type = type[type.length - 1];
    // if (type == 'csv') {
    //   this.state.curl = { base64: obj.base64, type: obj.type };
    //   this.setState(this.state);
    // }
    // else { toast.info('Only CSV format allowed!'); }
  }

  //createReview
  uploadCSV = () => {
    // let obj = {
    //   base64: this.state.curl.base64,
    //   type: this.state.curl.type,
    //   rmk: this.state.rmk
    // };
    // const formData = new window.FormData();
    // // Update the formData object 
    // formData.append(
    //   'myfile',
    //   this.state.selectedFile,
    // );
    // formData.append(
    //   'remark',
    //   this.state.rmk
    // );
    const formData = new window.FormData();
    formData.append('pn', 1);
    formData.append('cl', 0);
    formData.append('fuid', this.state.reviewFuid);
    formData.append('myfile', this.state.selectedFile);
    this.props.uploadCSV(formData);
    this.state.cptntxt = '';
    this.state.openCloseData = false;
    this.state.pageNoReview = 1;
    this.state.reviewDataItems = [];
    this.state.totalCountOfData = 0;
    this.state.wbstlnk = '';
    this.state.wbstlg1 = '';
    this.state.wbstlg = '';
    this.state.fuid = '';
    this.state.un = '';
    this.state.rtng = '5';
    this.state.adcr = '0';
    this.state.msg = '';
    this.state.rtxt = '';
    this.state.isAddnewRec = false;
    this.setState(this.state);
    document.getElementById('csvUploadFile').value = '';
  }


  render() {
    // themeData.intMstDT
    let { openClose, searchByApp } = this.state;//searchByApp
    let { widgetById, allProps } = this.props;
    arrDataSource = [];
    this.props.widgetById && this.props.widgetById.dsi && widgetById.dsi.filter(dsi => {
      arrDataSource.push({
        uid: dsi.uid,
        pid: dsi.pid,
        wid: widgetById._id,
        dsi: dsi
      });
    });
    let arrInt = [];//, arrCt = [];//Dynamic tab
    if (allProps.lstActiveIntg && allProps.lstActiveIntg.length > 0) {
      let integrationData = [];
      if (this.props.filterType) {//For Filter from the data source
        integrationData = allProps.lstActiveIntg.filter(x => x.typ.indexOf(this.props.filterType) !== -1);
      }
      else {
        integrationData = allProps.lstActiveIntg;
      }
      if (searchByApp) {
        let reg = new RegExp(searchByApp.toLowerCase().replace(/\W/g, ''));
        let filIntData = integrationData;
        integrationData = filIntData.filter(x => {
          let dn = x.dn.toLowerCase();
          if (reg.test(dn.replace(/ /g, '')) === true) {
            return x;
          }
        });
      }
      arrInt = integrationData;
    }
    arrInt && arrInt.sort((a, b) => {
      if (a.in < b.in) {
        return -1;
      }
      if (a.in > b.in) {
        return 1;
      }
      return 0;
    });
    arrInt && arrInt.sort((a, b) => {
      if (a.do < b.do) {
        return -1;
      }
      if (a.do > b.do) {
        return 1;
      }
      return 0;
    });

    //Start Custom webhook mapping section
    let uData = '';//User Integration Data Variable
    let objk = {//Object For WiserNotify Key
      un: '{{USERNAME}}',
      e: '{{EMAIL}}',
      phn: '{{PHONE}}',
      ct: '{{CITY}}',
      st: '{{STATE}}',
      cn: '{{COUNTRY}}',
      pn: '{{PRODUCT_NAME}}',
      pu: '{{PRODUCT_URL}}',
      piu: '{{PRODUCT_IMAGE}}',
      insdt: '{{CAPTURE_DATE}}',
      fn: '{{F_NAME}}',
      ln: '{{L_NAME}}',
      cst1: '{{CUSTOM_1}}',
      cst2: '{{CUSTOM_2}}',
      cst3: '{{CUSTOM_3}}'
    };
    //Return only one record open slide panel then get one record using User Integration ID
    if (this.state.usIntId && this.props.userIntegration) {
      uData = this.props.userIntegration.filter(x => x._id.toString() == this.state.usIntId);
    }
    //if option already in database then remove this option using map
    uData && this.state.usIntId && uData.length > 0 &&
      uData[0] && uData[0].amp && uData[0].amp.length > 0 &&
      uData[0].amp.map((value) => {
        const keys = Object.keys(value)[0];
        for (const key1 in objk) {
          if (objk[key1] == keys) {
            delete objk[key1];
          }
        }
      });
    //End
    return (
      <div className=" ">
        {/* integration-tabs */}
        <div className="">
          <div>
            {openClose === false && <div className="integration-tab-content">
              <div className="row">
                <div className="col-xs-12" >
                  <div className='integration-slipanel-header'>
                    <div className='integraslipanel-header-top'>
                      <h4 onClick={() => this.hideShowDataSource('close')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12">
                          <path id="Path_59544" data-name="Path 59544" d="M10.9,7,12,5.917,6,0,0,5.917,1.1,7,6,2.165l.065.064Z" transform="translate(0 12) rotate(-90)" fill="#645cfc" opacity="0.987" />
                        </svg>
                        Select Integration
                      </h4>
                      <div className='integration-slipanel-close' onClick={() => this.hideShowDataSource('close')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
                          <path id="Path_59483" data-name="Path 59483" d="M-440.148-160.721l3.3-3.3a1,1,0,0,0,0-1.407,1.019,1.019,0,0,0-1.408,0l-3.3,3.3-3.3-3.3a1.017,1.017,0,0,0-1.405,0,.986.986,0,0,0-.292.7.988.988,0,0,0,.292.7l3.3,3.3-3.3,3.3a.987.987,0,0,0-.292.7.988.988,0,0,0,.292.7,1,1,0,0,0,1.406,0l3.3-3.3,3.3,3.3a1,1,0,0,0,.7.291.992.992,0,0,0,.7-.291,1,1,0,0,0,0-1.407Z" transform="translate(446.554 165.712)" fill="#645cfc" />
                        </svg>
                      </div>
                    </div>
                    <div className='integraslipanel-header-search'>
                      {openClose === false && this.state.isAllInOne == true && <input type="text"
                        id="searchByApp" name="searchByApp"
                        onChange={(e) => this.handleSearchState(e)}
                        value={searchByApp}
                        disabled={this.state.isDisable}
                        className="nf-input nf-input-sm input-left-inicon integraslipanel-input-searchapp"
                        placeholder="Search by app" />}
                    </div>
                  </div>
                  {/* <p>sdsdfsdf</p> */}
                </div>

                <div className="col-xs-12" >
                  {this.state.islstIntLoading === true ?
                    <ContentLoader
                      height={750}
                      width={1750}
                      speed={2}
                      primaryColor="#fff"
                      secondaryColor="#eceef4"
                    >
                      <rect x="50" y="100" rx="0" ry="0" width="1650" height="800"></rect>
                    </ContentLoader>
                    :
                    arrInt && arrInt.length > 0 ? arrInt.map((value, key) => {
                      return (
                        <div className="apps-connect-list" onClick={() => this.opCLIntModel(value)} key={key}>
                          <div className="apps-integra-img">
                            <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                          </div>
                          <div className="connect-list-name">
                            <h4 style={{ cursor: 'pointer' }}>{value.dn} {value.ver && <sup>beta</sup>}</h4>
                            {/* {value.icsn ?
                              <div className="connect-list-tooltip">
                                <img data-tip data-for={value._id} src={IconInformation} alt="" />
                                <ReactTooltip id={value._id} aria-haspopup='true' role='example'>
                                  <p>Coming soon..</p>
                                </ReactTooltip>
                              </div>
                              :
                              <div className="connect-list-tooltip">
                              </div>
                            } */}
                          </div>
                          <div className='apps-integra-img-arrow'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12">
                              <path id="Path_59545" data-name="Path 59545" d="M10.9,0,12,1.083,6,7,0,1.083,1.1,0,6,4.835l.065-.064Z" transform="translate(0 12) rotate(-90)" fill="#645cfc" opacity="0.987" />
                            </svg>
                          </div>
                        </div>
                      );
                    }) :
                      <div className="col-xs-12 mt-15">
                        <p className='text-center'>No record found</p>
                      </div>
                  }
                </div>
              </div>
            </div>}
            {openClose === true && this.renderIntData()}

          </div>
        </div>
        <div className="sliding-default  slide-intrag-review 111">
          <SlidingPanel
            type={'left'}
            isOpen={this.state.openCloseSideDataPanel}
            size={25}>
            {/* backdropClicked={this.closeDataPanel}> */}
            <div className="intrag-review-wrap  222">

              <div className="edit-review-wrapper">
                {this.state.openCloseData == true &&
                  <div className="edit-review-content">

                    <div className="edit-review-header" onClick={() => this.closeModalData()}>
                      <svg className="link-svg " xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 12 20">
                        <path id="collsapn-arrow" d="M11.587,10.928,2.565,19.951a1.111,1.111,0,0,1-1.568,0l-.665-.665a1.111,1.111,0,0,1,0-1.568L7.909,10.14.324,2.557a1.111,1.111,0,0,1,0-1.568L.988.324a1.111,1.111,0,0,1,1.568,0l9.03,9.03a1.12,1.12,0,0,1,0,1.574Z" transform="translate(11.894 20) rotate(-177)" fill="#8FA7C4" />
                      </svg>
                      <div className="title-dataset-label cursor">
                        <h6 className='sidepanel-integration-title' style={{ textTransform: 'capitalize' }}>{this.state.dnForEditRevie}</h6>
                      </div>
                    </div>
                    {this.state.iconLoader == true && this.state.openCloseIconModel == false ?
                      Array(10)
                        .fill('')
                        .map((e, i) => (
                          <TableRow key={i} style={{ opacity: Number(2 / i).toFixed(1) }} />
                        )) :
                      <div className="edit-review-elementor">
                        {/* <h5 className='' style={{ fontWeight: '500', margin: '0px 0px 8px', color: '#212121' }}>Add a review</h5> */}
                        {this.state.isAddnewRec == true && <h5 className='importreview-title'>Add reviews manually or via CSv:</h5>}
                        {this.state.isAddnewRec == true && <div className='formcheck-mnly-csv'>
                          <div class="form-check form-check-inline form-check-active">
                            <input class="form-check-input" type="radio" name="adcr" checked={this.state.adcr == '0' ? true : false} id="exampleRadios1" value="0" onClick={(e) => this.handleStateChangeInt(e)} />
                            <label class="form-check-label" for="exampleRadios1">
                              Add reviews manually
                            </label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="adcr" checked={this.state.adcr == '1' ? true : false} id="exampleRadios2" value="1" onClick={(e) => this.handleStateChangeInt(e)} />
                            <label class="form-check-label" for="exampleRadios2">
                              Import reviews via CSV
                            </label>
                          </div>
                        </div>}
                        {this.state.adcr == '0' && <div>
                          <form className="edit-review-form">
                            <div className="nf-group-input">
                              <label>Reviewer name</label>
                              <input type="text"
                                name="un"
                                className="editor-input-content editor-input-fullwidth"
                                id=""
                                placeholder='Name'
                                value={this.state.un}
                                onChange={(e) => this.handleStateChangeInt(e)}
                              />
                              {this.rtValidator.message('Reviewer name', this.state.un, 'required|required')}
                            </div>
                            {this.state.in == 'importreviews' && <div className="nf-group-input">
                              <label>Reviewer image</label>
                              <div className="nf-group-input">
                                <div className="icon-setting-block">
                                  {
                                    this.state.piu ?
                                      <div className="icon-box">
                                        <img
                                          className="editor-input-content"
                                          id=""
                                          src={this.state.piu}
                                        />
                                        <span onClick={() => this.removeReviewImage()} className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 17.181 17.09">
                                            <path id="Path_232" data-name="Path 232" d="M295.416,385.5l6.292-6.292a1,1,0,0,0-1.414-1.415L294,384.089l-6.292-6.292a1,1,0,1,0-1.415,1.415l6.293,6.292-6.293,6.292a1,1,0,0,0,1.415,1.415L294,386.92l6.293,6.292a1,1,0,0,0,1.414-1.415Zm0,0" transform="translate(-285.41 -376.914)" fill="#fb5360" stroke="#fb5360" stroke-width="1" />
                                          </svg>
                                        </span>
                                      </div>
                                      :
                                      <div className="icon-box">
                                        <img
                                          className="editor-input-content"
                                          id=""
                                          src="https://storage.googleapis.com/widget_img/widget/default_share.png"
                                        />
                                      </div>
                                  }
                                  <div className="icon-edit cursor" onClick={() => this.openIconModel(this.state.fuid, 'piu')}>
                                    <img src={EditWhite} alt="" />
                                  </div>
                                </div>
                              </div>
                            </div>}
                            <div className="nf-group-input">
                              <label>Ratings</label>
                              <Dropdown
                                className="nf-select-dropdown nf-select-defaultdd  nf-select-conditondd nf-select-desgn"
                                name="rtng"
                                options={ratingOption}
                                value={this.state.rtng}
                                onChange={(e) => this.handleInputchange('rtng', e)}
                              />
                            </div>
                            {/* <div className="nf-group-input">
                          <label>Rating Text</label>
                          <input type="text"
                            name="msg"
                            className="editor-input-content editor-input-fullwidth"
                            id=""
                            placeholder='Rating Text'
                            value={this.state.msg}
                            onChange={(e) => this.handleStateChangeInt(e)}
                          />
                        </div> */}
                            <div className="nf-group-input">
                              <label>Review text</label>
                              <textarea
                                name="rtxt"
                                className="editor-input-content editor-input-fullwidth"
                                id=""
                                cols="5"
                                rows="5"
                                placeholder='Text'
                                value={this.state.rtxt}
                                onChange={(e) => this.handleStateChangeInt(e)}
                              >
                              </textarea>
                              {this.rtValidator.message('Review text', this.state.rtxt, 'required|required')}
                            </div>
                            {this.state.in == 'importreviews' && <div className="nf-group-input">
                              <label>Review Source</label>
                              <Dropdown
                                className="nf-select-dropdown  nf-select-desgn nf-ddselect-cstmsource"
                                name="styp"
                                options={sourceOption}
                                value={this.state.styp ? this.state.styp : 'custom'}
                                onChange={(e) => this.handleInputchange('styp', e)}
                              />
                            </div>}
                            {this.state.in == 'importreviews' && <div className="nf-group-input">
                              <label>Source URL</label>
                              <input type="text"
                                name="pu"
                                className="editor-input-content editor-input-fullwidth"
                                id=""
                                placeholder='Name'
                                value={this.state.pu}
                                onChange={(e) => this.handleStateChangeInt(e)}
                              />
                            </div>}
                            <div className="nf-group-input">
                              <label>Reviewers designation and company name</label>
                              <input type="text"
                                name="cptntxt"
                                className="editor-input-content editor-input-fullwidth"
                                id=""
                                placeholder='Detail'
                                value={this.state.cptntxt}
                                onChange={(e) => this.handleStateChangeInt(e)}
                              />
                            </div>
                            <div className="nf-group-input">
                              <label>Website URL</label>
                              <input type="text"
                                name="wbstlnk"
                                className="editor-input-content editor-input-fullwidth"
                                id=""
                                placeholder="Website URL"
                                value={this.state.wbstlnk}
                                onChange={(e) => this.handleStateChangeInt(e)}
                              />
                            </div>
                            <div className="nf-group-input">
                              <label>Website Logo</label>
                              <div className="nf-group-input">
                                <div className="icon-setting-block">
                                  {
                                    this.state.wbstlg ?
                                      <div className="icon-box">
                                        <img
                                          className="editor-input-content"
                                          id=""
                                          src={this.state.wbstlg}
                                        />
                                        <span onClick={() => this.removeImage()} className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 17.181 17.09">
                                            <path id="Path_232" data-name="Path 232" d="M295.416,385.5l6.292-6.292a1,1,0,0,0-1.414-1.415L294,384.089l-6.292-6.292a1,1,0,1,0-1.415,1.415l6.293,6.292-6.293,6.292a1,1,0,0,0,1.415,1.415L294,386.92l6.293,6.292a1,1,0,0,0,1.414-1.415Zm0,0" transform="translate(-285.41 -376.914)" fill="#fb5360" stroke="#fb5360" stroke-width="1" />
                                          </svg>
                                        </span>
                                      </div>
                                      :
                                      <div className="icon-box">
                                        <img
                                          className="editor-input-content"
                                          id=""
                                          src="https://storage.googleapis.com/widget_img/widget/default_share.png"
                                        />
                                      </div>
                                  }
                                  <div className="icon-edit cursor" onClick={() => this.openIconModel(this.state.fuid, 'wbstlg')}>
                                    <img src={EditWhite} alt="" />
                                  </div>
                                </div>
                              </div>
                              {/* {this.state.wbstlg ? <img
                            className="editor-input-content"
                            id=""
                            src={this.state.wbstlg}
                            onClick={() => this.removeImage()}
                          /> :
                            <img
                              className="editor-input-content"
                              id=""
                              src="https://storage.googleapis.com/widget_img/widget/default_share.png"
                            />
                          }
                          <button type='button' className="nf-btn  nf-btn-primary"
                            onClick={() => this.openIconModel(this.state.fuid)}>
                            Upload Image
                          </button> */}
                            </div>
                          </form>
                          <div className="nf-btn-reviewup text-center mt-20 edit-review-adddownload">
                            <button type='button' className="nf-btn nf-btn-white nf-btn-noneBdr nf-btn-cancel"
                              onClick={() => this.closeModalData()}>
                              Cancel
                            </button>
                            {this.state.isAddnewRec == false ?
                              <button type='button' className="nf-btn nf-btn-default nf-btn-noneBdr nf-bt-updsav"
                                onClick={() => this.updateReview(this.state.fuid, 'updateBtn')}>
                                Update
                              </button> :
                              <button type='button' className="nf-btn nf-btn-default nf-btn-noneBdr nf-bt-updsav"
                                onClick={() => this.addCutomReview()}>
                                Save
                              </button>
                            }
                          </div>
                        </div>}
                        {this.state.adcr == '1' && <div className='impotrvw-viacsv-block'>
                          <div className="wdgt-group-input mt-15">
                            <div className='d-flex align-items-center impotrvw-download-label'>
                              <label className="">Import Reviews</label>
                              <div className='impotrvw-download-csv' onClick={() => getDemoCsv()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                                  <path id="Path_59598" data-name="Path 59598" d="M-6570.476,11528h-11.049a.468.468,0,0,1-.474-.46v-2.677a.469.469,0,0,1,.474-.463.47.47,0,0,1,.475.463v2.22h10.1v-2.22a.47.47,0,0,1,.475-.463.471.471,0,0,1,.477.463v2.677A.469.469,0,0,1-6570.476,11528Zm-5.523-2.4a.378.378,0,0,1-.275-.116l-2.01-2.077a.417.417,0,0,1,0-.575.39.39,0,0,1,.278-.117.39.39,0,0,1,.277.117l1.339,1.389v-7.814a.4.4,0,0,1,.394-.405.381.381,0,0,1,.272.113.409.409,0,0,1,.115.292v7.814l1.34-1.389a.39.39,0,0,1,.278-.117.39.39,0,0,1,.277.117.418.418,0,0,1,0,.575l-2.011,2.077A.377.377,0,0,1-6576,11525.6Z" transform="translate(6582 -11515.999)" fill="#3cca73" />
                                </svg>
                                <span>Download CSV Template</span>
                              </div>
                            </div>
                            <div className='impotrvw-browser-input'>
                              <input type='file' id='csvUploadFile' onChange={(e) => this.CSVfile(e)} />
                            </div>
                          </div>
                          <button onClick={() => this.uploadCSV()} type='button' className="nf-btn nf-btn-default nf-btn-noneBdr nf-bt-updsav">
                            Upload
                          </button>
                        </div>}
                      </div>
                    }
                  </div>
                }
                {/* edit review side panel */}
                {this.state.openCloseData == false &&
                  <div className='edit-review-block'>
                    <div className="rightbar-title">
                      <h4 className="sidepanel-integration-title">
                        {this.props.state.usIntObj.rmk ?
                          `Reviews in ${this.props.state.usIntObj.rmk}`
                          :
                          this.props.state.usIntObj.pgObj ?
                            this.state.in === this.props.state.usIntObj.inm && this.props.state.usIntObj.pgObj.locationName &&
                            `Reviews in ${this.props.state.usIntObj.pgObj.locationName}`
                            :
                            this.state.in === this.props.state.usIntObj.inm && this.props.state.usIntObj.pgObj.name &&
                            `Reviews in ${this.props.state.usIntObj.pgObj.name}`
                        }
                      </h4>
                      {this.state.fuid == '' &&
                        <button className="btn-close-rightbar " onClick={this.closeDataPanel}>
                          <svg className='brand-path-color' xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 9.99">
                            <path id="Path_59483" data-name="Path 59483" d="M-440.148-160.721l3.3-3.3a1,1,0,0,0,0-1.407,1.019,1.019,0,0,0-1.408,0l-3.3,3.3-3.3-3.3a1.017,1.017,0,0,0-1.405,0,.986.986,0,0,0-.292.7.988.988,0,0,0,.292.7l3.3,3.3-3.3,3.3a.987.987,0,0,0-.292.7.988.988,0,0,0,.292.7,1,1,0,0,0,1.406,0l3.3-3.3,3.3,3.3a1,1,0,0,0,.7.291.992.992,0,0,0,.7-.291,1,1,0,0,0,0-1.407Z" transform="translate(446.554 165.712)" fill="#645cfc" />
                          </svg>
                        </button>}
                    </div>
                    <div className='edit-review-adddownload'>
                      {this.state.typ && this.state.typ.length > 0 && this.state.in == 'importreviews' &&
                        <button onClick={() => this.openAddDataModal()} className="nf-btn nf-btn-default nf-btn-noneBdr">
                          Add review manually
                        </button>
                      }
                      {this.state.typ && this.state.typ.length > 0 && this.state.typ.indexOf('customreview') !== -1 && this.state.reviewDataItems && this.state.reviewDataItems.length > 0 &&
                        <button onClick={this.downloadExcelData} disabled={this.state.isExcelDownload} className="nf-btn nf-btn-default nf-btn-noneBdr nf-btn-download">
                          Download
                        </button>
                      }
                    </div>
                    <div className='title-connection-name'>Review list</div>
                    <div className='edit-review-scroll-block'>
                      <ul className='edit-review-list' id='edit_scroll'>
                        {
                          this.state.reviewDataItems && this.state.reviewDataItems.length > 0 ?
                            this.state.reviewDataItems.map((obj, i) => {
                              return (
                                <li className='edit-review-item' key={i}>
                                  <div className='edit-review-leftpart'>
                                    <h5>{obj.fn ? obj.fn : '-'}</h5>
                                    <p>{obj.rtxt ? obj.rtxt : '-'}</p>
                                  </div>
                                  <div className='edit-review-rightpart'>
                                    {obj.fa !== 'customcollectorreview' &&
                                      <Link onClick={() => this.editReview(obj)} className="btn-action nf-btn light-bg-icon btn-icon-30 tbl-action-dlt">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                                          <path id="Path_59457" data-name="Path 59457" d="M-656.586,37.444V44.3h-14v-13.7h7v1.37h-5.6V42.927h11.2V37.444Zm-9.1.214,5.615-5.508,1.089,1.4-5.682,5.954h-1.021Zm-1.4,3.213h3.02l6.935-7.322-2.9-3.252-7.053,6.78Z" transform="translate(670.586 -30.297)" fill="#8392a5" />
                                        </svg>
                                      </Link>
                                    }
                                    <Link onClick={() => this.deleteReview(obj._id, obj.fuid)} className="btn-action nf-btn btn-delete-light light-bg-icon btn-icon-30 tbl-action-dlt">
                                      <svg id="Group_29020" data-name="Group 29020" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                                        <rect id="Rectangle_135" data-name="Rectangle 135" width="1.264" height="5.509" transform="translate(7.785 5.664)" fill="#f06548" />
                                        <path id="Path_162" data-name="Path 162" d="M-127.23,5.132V2.295h-6.927V5.132H-137.7V6.386h2.122V16.3h9.755V6.386h2.123V5.132ZM-128.5,3.559V5.132h-4.41V3.559Zm-5.765,11.482V6.386h7.185v8.655Z" transform="translate(137.699 -2.295)" fill="#f06548" />
                                        <rect id="Rectangle_136" data-name="Rectangle 136" width="1.254" height="5.509" transform="translate(4.959 5.664)" fill="#f06548" />
                                      </svg>
                                    </Link>
                                  </div>
                                </li>
                              );
                            })
                            :
                            <li className='edit-review-item'>
                              <div className="edit-review-leftpart">
                                <h5>No record found</h5>
                              </div>
                            </li>
                        }
                      </ul>
                      {this.state.reviewDataItems.length < this.state.totalCountOfData &&
                        <div className='edit-review-list-morebtn text-center' onClick={() => this.getReviewPaging()}>
                          <Link className="link-text-brand">
                            <b>{this.state.reviewDataItems.length} </b> record displayed out of <b>{this.state.totalCountOfData}</b>  records
                          </Link>
                        </div>}
                    </div>
                  </div>
                }



                {/* {this.state.openCloseData == false &&
                  <table className="table tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-webllist">
                    <thead className="thead-light">
                      <tr>
                        <th className="text-nowrap">Name</th>
                        <th className="text-nowrap">Message</th>
                        <th className="text-nowrap">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(this.state.isLoaderForReviewDiv == true || this.state.iconLoader == true) ?
                        Array(16)
                          .fill('')
                          .map((e, i) => (
                            <tr>
                              <td colSpan="3">
                                <TableRow1 key={i} style={{ opacity: Number(2).toFixed(1) }} />
                              </td>
                            </tr>
                          ))
                        :
                        this.state.reviewDataItems && this.state.reviewDataItems.length > 0 ?
                          this.state.reviewDataItems.map((obj, i) => {
                            return (<tr key={i}>
                              <td>{(i + 1)}</td>
                              <td>
                                <div className="tbl-rvwtext-line" data-tip data-for={obj._id} data-place="bottom"	>
                                  <ReactTooltip id={obj._id} aria-haspopup='true' role='example'>
                                    <p>{obj.un ? obj.un : '-'}</p>
                                  </ReactTooltip>
                                  {obj.fn ? obj.fn : '-'}
                                </div>
                              </td>
                              <td>{obj.ln ? obj.ln : '-'}</td>
                              <td>
                                <div className="tbl-rvwtext-line"	>
                                  {obj.rtxt ? obj.rtxt : '-'}
                                </div>
                                <div className="tbl-rvwtext-line" data-tip data-for={obj._id} data-place="bottom"	>
                                <ReactTooltip id={obj._id} aria-haspopup='true' role='example'>
                                  <p>{obj.msg ? obj.msg : '-'}</p>
                                </ReactTooltip>
                                {obj.msg ? obj.msg : '-'}
                              </div>
                              </td>
                              <td>
                                <div className="integra-checklist-item">
                                  {obj.fa !== 'customcollectorreview' &&
                                    <span
                                      onClick={() => this.editReview(obj)}
                                      className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 14.233 14.164">
                                        <path id="Path_240" data-name="Path 240" d="M-31.27,55.361l2.9,2.9L-35.7,65.586l-2.894-2.9Zm5.092-.7-1.291-1.291a1.281,1.281,0,0,0-1.81,0l-1.237,1.237,2.9,2.9,1.443-1.443a.987.987,0,0,0,0-1.4Zm-13.935,12.1a.329.329,0,0,0,.4.392l3.226-.782-2.894-2.9Zm0,0" transform="translate(40.12 -52.998)" fill="#909da3"></path>
                                      </svg>
                                    </span>}
                                  <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => this.deleteReview(obj._id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                      <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                        <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                        <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                      </g>
                                    </svg>
                                  </span>
                                </div>
                              </td>
                            </tr>
                            );
                          })
                          :
                          <tbody>
                            <tr>
                              <td>No record found</td>
                            </tr>
                          </tbody>
                      }

                      {this.state.reviewDataItems.length < this.state.totalCountOfData && <tr>
                        <td
                          colSpan="11"
                          onClick={() => this.getReviewPaging()}
                          style={{ textAlign: 'center', cursor: 'pointer' }}>
                          <div className="tbl-page-record">
                            <a className="nf-btn nf-btn-default nf-btn-noneBdr" style={{ textDecoration: 'none' }}>
                              Load more
                            </a>
                            <span className="tbl-page-number"> <b>{this.state.reviewDataItems.length} </b> record displayed out of <b>{this.state.totalCountOfData}</b>  records</span>
                          </div>
                        </td>
                      </tr>}
                    </tbody>
                  </table>
                } */}


              </div>
            </div>
          </SlidingPanel>

          {/* Start Custom webhook field mapping */}
          <div className="datasource-sidepanel">
            <SlidingPanel
              type={'right'}
              isOpen={this.state.openCloseCustomWBPanel}
              size={50}>
              <div>
                <div className="rightbar-title">
                  <h4 className="sidepanel-integration-title">
                    <i className="iconmoon icon-integration "></i>
                    Field Mapping
                  </h4>
                  <button className="btn-close-rightbar" onClick={() => this.closeCustomWBPanel()}>
                    <img src={IconClose} alt="close" />
                  </button>
                </div>
                <div className="main-container  integration-extra-layout">
                  <div className="header-sub-title">
                    <p>{(this.props.customWBFields && this.props.customWBFields.resp && this.props.customWBFields.resp.length == 0) || !this.props.customWBFields ?
                      'Please post sample data on the webhook URL from your third party platform.'
                      :
                      'Click on start listening & post a data on webhook URL from your third party platform.'
                    }</p>
                    <div className="nf-btn-startlsting">
                      <button type='button' className="nf-btn  nf-btn-default" onClick={() => this.updCustomField(this.state.usIntId)} disabled={(this.props.customWBFields && this.props.customWBFields.resp && this.props.customWBFields.resp.length == 0) || !this.props.customWBFields}>
                        {(this.props.customWBFields && this.props.customWBFields.resp && this.props.customWBFields.resp.length == 0) || !this.props.customWBFields ?
                          'Waiting for data'
                          :
                          'Start listening'
                        }
                      </button>
                      {!this.props.customWBFields ?
                        <div className="loader-pixel nf-btn-min15x 1">
                          <div className="spinner-pixel"></div>
                        </div> :
                        this.props.customWBFields && this.props.customWBFields && this.props.customWBFields.resp && this.props.customWBFields.resp.length == 0 ?
                          <div className="loader-pixel nf-btn-min15x 2">
                            <div className="spinner-pixel"></div>
                          </div>
                          : (this.props.customWBFields && this.props.customWBFields.resp && this.props.customWBFields.resp.length == 0) || !this.props.customWBFields ? '' : this.state.isLisDtSuc == true &&
                            <p id="sucess-data-rec-p">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Data received successfully! Please map WiserNotify keywords with received Key/Values.</p>
                      }
                    </div>
                    <h4 className="mb-2">Do mapping between Wisernotify & Webhook data:</h4>
                  </div>
                  <div className="pull-right">
                    {/* <label>Custom Field</label> */}
                    {/* <label className="switch-update switch-update-notilist">
                    <input type="checkbox" checked={this.state.icst} disabled={!checkPermission('integration', 'isedit', this.props.profile)} onChange={() => this.activeCustFld(this.state.usind)} />
                    <span className="slider round">
                      <samp className="slider-cricle">
                        <svg className="checkbox-insign checkbox-true" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 20.028 14.958">
                          <path id="checkbox-true" d="M292.95,374.934l-11.8,11.8a.264.264,0,0,1-.376,0l-6.7-6.7a.263.263,0,0,1,0-.375l1.628-1.628a.264.264,0,0,1,.376,0l4.883,4.883,9.982-9.983a.264.264,0,0,1,.376,0l1.627,1.628a.265.265,0,0,1,0,.376Zm0,0" transform="translate(-273.5 -372.352)" fill="#fff" stroke="#fff" strokeWidth="1" />
                        </svg>
                        <svg className="checkbox-insign checkbox-false" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 18.689 18.69">
                          <path id="checkbox-false" d="M279.237,367.344l6.338-6.338a.389.389,0,0,0,0-.551l-2.342-2.342a.389.389,0,0,0-.551,0l-6.338,6.338-6.338-6.338a.4.4,0,0,0-.551,0l-2.342,2.342a.389.389,0,0,0,0,.551l6.338,6.338-6.338,6.338a.389.389,0,0,0,0,.551l2.342,2.342a.389.389,0,0,0,.551,0l6.338-6.338,6.338,6.338a.387.387,0,0,0,.551,0l2.342-2.341a.39.39,0,0,0,0-.552Zm0,0" transform="translate(-267 -358)" fill="#fff" />
                        </svg>
                      </samp>
                    </span>
                  </label> */}
                  </div>
                  <div className="integra-custom-selectfield">
                    <div className="row">
                      <div className='col-xs-5'>
                        {/* <select className='nf-select ' onChange={(e) => handleArrayChange('ttlfnfml', key, e.target.value)} value={val.ttlfnfml}> */}
                        <select className='nf-select' name='custkeyword' onChange={(e) => this.handleCustomFieldkey(e)} value={this.state.custkeyword}>
                          <option value=''>--Select Keyword--</option>
                          {Object.keys(objk).map((key, index) => (
                            <option key={index} value={objk[key]}>{objk[key]}</option>
                          ))}
                        </select>
                      </div>
                      <div className='col-xs-5'>
                        <select className='nf-select ' id='wb-mp-fl' name='custvalue' onChange={(e) => this.handleCustomFieldkey(e)} value={this.state.custvalue}>
                          <option value=''>--Select Key/Value--</option>
                          {this.props.customWBFields && this.props.customWBFields.resp && this.props.customWBFields.resp.length > 0
                            && this.props.customWBFields.resp.map(((x, i) => {
                              return <option key={i} value={x}>{x}</option>;
                            }))
                          }
                        </select>
                        {/* {uData && uData.length > 0 &&
                          uData[0] && uData[0].amp && uData[0].amp.length == 0 && <span id="sucess-data-rec-p">Data received</span>} */}
                      </div>
                      <div className='col-xs-2'>
                        <div className="">
                          <button type='button' className="nf-btn  nf-btn-default" onClick={() => this.addCustomField()}>
                            Add
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <table className="table tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-app-list">
                        <thead className="">
                          <tr>
                            <th>#</th>
                            <th>Key</th>
                            <th>Value</th>
                            <th>Created Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {uData && uData.length > 0 &&
                            uData[0] && uData[0].amp && uData[0].amp.length > 0 ?
                            uData[0].amp.map((value, i) => (
                              <tr key={i} style={{ width: '100%' }}>
                                <td>{i + 1}</td>
                                <td>{Object.keys(value)[0]}</td>
                                <td>{value[Object.keys(value)[0]]}</td>
                                <td>{value[Object.keys(value)[1]] ? moment(value[Object.keys(value)[1]]).format('MMM-DD-YYYY hh:mm:ss a') : ''}</td>
                                <td>
                                  <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-30  tbl-action-dlt" onClick={() => this.deleteCustomField({ key: Object.keys(value)[0], fuid: this.state.usIntId })}>
                                    <img className="" src={IconDelete} alt="google" data-tip data-for='cmdel' />
                                    <ReactTooltip id='cmdel' aria-haspopup='true' role='example'>
                                      <p>Delete mapping field</p>
                                    </ReactTooltip>
                                  </span>
                                </td>
                              </tr>
                            )) :
                            <tr>
                              <td colSpan='5' className="center-align">No record found</td>
                            </tr>}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </SlidingPanel>
          </div>
          {/* End Custom webhook field mapping */}




          {/* <ReviewData
            data={this.state}
            closeModal={this.closeModalData}
            handleStateChange={this.handleStateChangeInt}
            updateReview={this.updateReview}
            handleReviewImgChange={this.handleReviewImgChange}
            openIconModel={this.openIconModel}
          /> */}

        </div >
        <Modal
          id='iconModel'
          className='iconModel'
          title='Upload icon'
          content={this.iconModelCont()}
          openCloseModal={this.closeIconModel}
          style={
            {
              modalStyle: {
                display: this.state.openCloseIconModel ? 'block' : 'none',
                opacity: this.state.openCloseIconModel ? 1 : 0
              },
              alignModalStyle: {
                top: '210px'
              }
            }
          } />
      </div >
    );
  }

}

const mapStateToProps = state => ({
  loading: state.getIn(['loading', 'state']),
  profile: state.getIn(['auth', 'profile']),
  integration: state.getIn(['integration', 'integration']),
  userIntMst: state.getIn(['integration', 'userIntMst']),
  userIntegration: state.getIn(['integration', 'userIntegration']),
  webhooks: state.getIn(['integration', 'webhooks']),
  themeData: state.getIn(['master', 'themeData']),
  isLoader: state.getIn(['integration', 'isLoader']),
  reviewsData: state.getIn(['integration', 'reviewsData']),
  iconImages: state.getIn(['integration', 'iconImages']),
  deleteReviewID: state.getIn(['integration', 'deleteReviewID']),
  updReview: state.getIn(['integration', 'updReview']),
  excelDownload: state.getIn(['integration', 'excelDownload']),
  customWBFields: state.getIn(['integration', 'customWBField']),
  widgetById: state.getIn(['widget', 'widgetById']),
  isIntLoader: state.getIn(['integration', 'isIntLoader']),
  widgetList: state.getIn(['integration', 'widgetList'])
});


const mapDispatchToProps = {
  getUsIntMst, getFBPostInt, createFBPage, deleteFBList, deleteFB,
  getFBReviewInt, createFBReviewIntIA, deleteFBReviewIntIA, deleteFBReviewInt, updADUsInt,
  createGMBPostIntIA, getGGLPostInt, deleteGGLPostIntIA, deleteGGLPostInt,
  createGGLReviewIntIA, getGGLReviewInt, deleteGGLReviewIntIA, deleteGGLReviewInt,
  getTwitPostInt, createTwitterUN, deleteTwitter, getIntMstList, getInstaPostInt, createInstaPostInt, deleteInstaPostInt,
  getGooglePlace, createGooglePlace, deleteGooglePlace, getCapterra, createCapterra, deleteCapterra,
  syncReviews, getWebhook, createWebhook, deleteWebhook, twitterOauth, deleteUNorTag, updateFilter, getRSS, createRSS, deleteRSS,
  getTumblr, createTumblr, deleteTumblr, addDataSrc, delDataSrc, getWidgetForInt,
  getBooking, createBooking, deleteBooking, getTripAdvisor, createTripAdvisor, deleteTripAdvisor,
  getTrustpilot, createTrustpilot, deleteTrustpilot, getAirbnb, createAirbnb, deleteAirbnb,
  getYelp, createYelp, deleteYelp, getHotels, createHotels, deleteHotels,
  getEtsy, createEtsy, deleteEtsy, getHouzz, createHouzz, deleteHouzz, getEdmunds, createEdmunds, deleteEdmunds,
  getDealerRater, createDealerRater, deleteDealerRater, getOpenTable, createOpenTable, deleteOpenTable,
  geteBay, createeBay, deleteeBay, getBBB, createBBB, deleteBBB, getAmzon, createAmzon, deleteAmzon,
  getGooglePlay, createGooglePlay, deleteGooglePlay, getAppleAPP, createAppleAPP, deleteAppleAPP, syncLastestPages,
  getReviews, getAppSumo, createAppSumo, deleteAppSumo, updateReview, getImages, deleteImage, setIconImageURL,
  deleteReview, removeImage, addCutomReview, getCustomReview, createCustomReview, deleteCustomReview, downloadExcelData,
  getCustomWebhook, createCustomWebhook, deleteCustomWebhook, getCustomWBField, addCustomField, deleteCustomField,
  updCustomField, getCustomCollectorReview, createCustomCollectorReview, deleteCustomCollectorReview,
  getAliexpress, createAliexpress, deleteAliexpress, getG2, createG2, deleteG2, getYouTubeVideoGallery, createYouTubeVideoGallery, deleteYouTubeVideoGallery,
  getStamped, createStamped, deleteStamped, createTumblrPostInt, deleteTumblrPostInt, deleteInstaPost, getImportreview, createImportReview, deleteImportReview,
  uploadCSV, getTwitterTestimonial, createTwitterTestimonial, deleteTwitterTestimonial
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Integration);


// WEBPACK FOOTER //
// ./src/containers/Integration/Integration.js